import React, { Component, useRef, useState } from "react";
import { Redirect, Link, NavLink } from "react-router-dom";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import {
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Button,
  Col,
  Form,
  Popover,
  PopoverHeader,
  PopoverBody,
  Alert,
  FormFeedback,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import LoadingBar from "react-top-loading-bar";
import PhoneInput from "react-phone-input-2";
import { Multiselect } from "react-widgets";
//import Spinner from '../Assets/Spinner'
import {
  RingLoader,
  FadeLoader,
  DotLoader,
  PropagateLoader,
} from "react-spinners";

export function AddLibrary(urlOfTheLibrary) {
  const script = document.createElement("script");
  script.src = urlOfTheLibrary;
  script.async = true;
  document.body.appendChild(script);
}

class KOLidentification extends Component {
  // typeAheadref = useRef < Typeahead > (null);
  constructor(props) {
    super(props);
    this.state = {
      subClinicalKolEnabled: true,
      subSpecilityVisible: false,
      ShowBar: false,
      alert: null,
      redirect: false,
      redirectLogin: false,
      redirectSignup: false,
      redirecthome: false,
      redirectPClientViewKolList: false,
      redirectAdministrator: false,
      profiletypeErr: false,
      redirectVisitor: false,
      redirectResercher: false,
      redirectManager: false,
      redirectEmployee: false,
      redirectClientDashboard: false,
      redirectPClientDashboard: false,
      pretoken:"",
      redirectAdministratorDashboard: false,
      redirectVisitorDashboard: false,
      redirectKolProfile: false,
      redirectTermsandPrivacy: false,

      redirectServices: false,

      kdidentificationhidediv: false,
      kdprofilinghidediv: false,
      kdinteracthidediv: false,

      GetInTouchModal: true,

      ClientLoginModal: false,
      AdministratorLoginModal: false,
      VisitorLoginModal: false,
      KolProfileloginModal: false,
      WrongTeamAlertModal: false,
      ContactUsModal: false,
      NewGurusModal: false,
      NewClientsModal: false,
      TermsAndConditionModal: false,
      TermsAndConditionModalForTeam: false,

      //resercherd id for redirectig to researcher dashoard
      RID: "",
      resercher_name: "",
      kols: [
        { id: "clinical", label: "Clinical" },
        { id: "non-clinical", label: "Non-Clinical" },
      ],
      kolSubType: [
        { value: "Payers", label: "Payers" },
        { value: "HTA Experts", label: "HTA Experts" },
        {
          value: "Hospital Procurement Experts",
          label: "Hospital Procurement Experts",
        },
        { value: "Advocacy Group Experts", label: "Advocacy Group Experts" },
        {
          value: "MedTech Industry Experts",
          label: "MedTech Industry Experts",
        },
      ],
      GetInTouchData: {
        client_name: "",
        email_id: "",
        company_nm: "",
        mobile_no: "",
        designation: "",
        message: "",
        status: "New",
        // loginType: 'pre_client',
      },
      Procedure: "",
      procedureSelected: false,
      conditionSelected: false,
      // Manager info
      manager_id: "",
      manager_name: "",

      // Employee info
      employee_id: "",
      employee_name: "",

      speciality_id: "",
      speciality_name: "",

      // For validations
      PhoneErr: "",
      DesignationErr: "",
      MessageErr: "",
      UsernameErr: "",
      UseremailErr: "",
      CompanyNameErr: "",

      PasswordErr: "",
      SelectRoleErr: "",
      wrngUsPsErr: "",

      clientUsernameErr: "",
      clientPasswordErr: "",

      administratorUsernameErr: "",
      administratorPasswordErr: "",

      visitorUsernameErr: "",
      visitorPasswordErr: "",

      kolProfileUsernameErr: "",
      kolProfilePasswordErr: "",
      // /kolProfileSelectRoleErr: '',

      //For getting values of input
      loginData: {
        client_id: "",
        password: "",
        role: "",
        // loginType: 'team',
      },

      ClientLoginData: {
        login_id: "",
        password: "",
        login_type: "client",
      },
      teamLoginIdForTerms: "",
      //Administrator
      AdministratorLoginData: {
        login_id: "",
        password: "",
        login_type: "administrator",
      },
      //visitor
      VisitorLoginData: {
        login_id: "",
        password: "",
        login_type: "visitor",
      },

      KolProfileLoginData: {
        username: "",
        password: "",
        // kol_login_role: '',
      },
      kolLoginIdForTerms: "",

      contact_us: {
        first_name: "",
        last_name: "",
        organization: "",
        email_id: "",
        phone_no: "",
        country: "",
        learn_qpharma: "",
        representative_contact_me: "",
        qpharmas_products: "",
        technical_support_issue: "",
        need_of_assistance: "",
        receive_qpharma_news: "",
        describe_issue_question: "",
      },
      cuFirstNameErr: "",
      cuLastNameErr: "",
      cuOrganizaErr: "",
      cuEmailErr: "",
      cuPhoneErr: "",
      cuCountryErr: "",

      new_guru: {
        first_name: "",
        last_name: "",
        mobile_no: "",
        email_id: "",
        speciality: "",
        sub_speciality: "",
        procedure_type: "",
        country: "",
        state: "",
        current_place_of_work: "",
        department: "",
        linkedin_link: "",
        additional_info: "",
      },
      ngFirstNameErr: "",
      ngLastNameErr: "",
      ngEmailErr: "",
      cuPhoneErr: "",
      ngCountryErr: "",
      ngStateErr: "",

      new_client: {
        first_name: "",
        last_name: "",
        email_id: "",
        mobile_no: "",
        msg: "",
      },
      ncFirstNameErr: "",
      ncLastNameErr: "",
      ncEmailErr: "",
      // ncPhoneErr: '',

      service1: false,
      service2: false,
      service3: false,
      service4: false,
      service5: false,
      service6: false,

      // to get data from dropdown
      SpecialityData: [],
      ProcedureData: [],
      SubSpecialityData: [],
      CountryListData: [],
      StateData: [],

      // to set form values
      Speciality: "",
      SubSpecialityType: [],
      ProcedureType: [],

      Market: [],
      Market2: [],

      PersonalInformation: {},

      toggleForgotPasswordModal: false,
      ForgotPasswordData: {
        email_id: "",
        role: "",
      },
      selectedKol: "",
      searchModalOpen: false,
      kolFormSubmitted: false,
      countryList: [
        { value: "USA", label: "USA" },
        { value: "Canada", label: "Canada" },
        { value: "UK", label: "UK" },
        { value: "Germany", label: "Germany" },
        { value: "France", label: "France" },
        { value: "Italy", label: "Italy" },
        { value: "Spain", label: "Spain" },
      ],
      clinicalKolForm: {
        speciality: "",
        subSpeciality: "",
        procedure: "",
        country: "",
      },
      nonClinicalKolForm: {
        kolSubType: "",
        country: "",
        fullName: "",
        workEmail: "",
        phone: "",
        companyName: "",
        jobTitle: "",
        message: "",
      },
      nonClinicalContactFormSubmitted: false,
      showNonClinicalContactForm: false,
    };
  }

  componentDidMount = async () => {
    console.log("in componentDidMount");

    let getSession_pretoken = sessionStorage.getItem("token");
    if (getSession_pretoken !== null) {
      this.setState({
        pretoken: getSession_pretoken
      });
    }
    const options = {
      method: "POST",
    };
    // Speciality type data

    fetch(
      global.websiteUrl +
      "/service/KOL_landing/Get_Speciality_List",
      options
    )
      .then((Response) => Response.json())
      .then((findresponse) => {
        console.log(findresponse);
        var testDataSpeciality = findresponse.data;
        // console.log("testDataSpeciality", JSON.stringify(testDataSpeciality));
        if (findresponse.data != "undefined") {
          this.setState({
            SpecialityData: findresponse.data.map((e) => ({
              label: e.speciality_type,
              value: e.id,
            })),
          });
        }
      });
    // Country list(market)
    fetch(global.websiteUrl + "/service/Location/get_CountryList", options)
      .then((Response) => Response.json())
      .then((findresponse) => {
        console.log(findresponse);
        // var testDataCountryList = findresponse.Country_Details;
        // console.log("testDataCountryList", JSON.stringify(testDataCountryList));
        this.setState({
          countryList: findresponse.Country_Details.map(c => ({ "value": c.id, "label": c.country_name })),
          Client_Unique_id: findresponse.client_system_id,
        });
      });
  };

  setSubSpecility = (id) => {
    const formdata = new FormData();
    formdata.append("speciality_type_id", id);
    const options = {
      method: "POST",
      body: formdata,
    };
    // Speciality type data
    const url = "/service/KOL_landing/Get_Sub_Speciality_List";
    fetch(global.websiteUrl + url, options)
      .then((Response) => Response.json())
      .then((findresponse) => {
        let subSpecilityList = findresponse.data.map(e => ({
          label: e.sub_speciality_type,
          value: e.id,
        }))
        if (findresponse.data != "undefined") {
          this.setState({
            SubSpecialityType: subSpecilityList,
            subSpecilityVisible: subSpecilityList[0].label !== "NA" ? true : false
          });
        }
      });
  };

  toggleGetInTouchModal() {
    //console.log("loginclicked")

    this.setState({
      GetInTouchModal: !this.state.GetInTouchModal,
    });
  }

  //login = toggle validate and login
  toggleLoginModal() {
    this.setState({
      redirectLogin: true,
    });
  }

  toggleSignUpModal() {
    sessionStorage.removeItem("quotation_id", "");
    this.setState({
      redirectSignup: true,
    });
  }

  toggleWithoutidModal() {
    setTimeout(function () {
      window.location.reload();
    }, 3000);
  }

  closeSearchModal() {
    this.setState({ searchModalOpen: false, kolFormSubmitted: false });
  }

  closeNonClinicalContactModal() {
    this.setState({ showNonClinicalContactForm: false });
  }

  openSearchModal() {
    if (this.state.selectedKol != "") {
      console.log(this.state.selectedKol);
      this.setState({ searchModalOpen: true });
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops",
        text: "Please select KOL",
        confirmButtonColor: "#d33",
        confirmButtonText: "OK",
      });
    }
  }

  makespaceondivkdidentification() {
    this.setState({
      hidedivkdprofiling: false,
      hidedivkdinteract: false,
      hidedivkdidentification: true,
    });
  }

  makespaceondivkdprofiling() {
    this.setState({
      hidedivkdidentification: false,
      hidedivkdinteract: false,
      hidedivkdprofiling: true,
    });
  }

  makespaceondivkdinteract() {
    this.setState({
      hidedivkdidentification: false,
      hidedivkdprofiling: false,
      hidedivkdinteract: true,
    });
  }

  makespaceondivhome() {
    this.setState({
      hidedivkdidentification: false,
      hidedivkdprofiling: false,
      hidedivkdinteract: false,
    });
  }

  validate = () => {
    let UsernameErr = "";
    let UseremailErr = "";
    let CompanyNameErr = "";
    let PhoneErr = "";
    let DesignationErr = "";
    let MessageErr = "";

    if (!this.state.GetInTouchData.client_name) {
      UsernameErr = "Please Enter Full Name";
    }
    if (!this.state.GetInTouchData.email_id) {
      UseremailErr = "Please Enter Email id";
    }

    if (!this.state.GetInTouchData.company_nm) {
      CompanyNameErr = "Please Enter Company Name";
    }

    if (!this.state.GetInTouchData.mobile_no) {
      PhoneErr = "Please Enter phone";
    }

    if (!this.state.GetInTouchData.designation) {
      DesignationErr = "Please Enter designation";
    }

    if (!this.state.GetInTouchData.message) {
      MessageErr = "Please Enter message";
    }

    if (
      UsernameErr ||
      UseremailErr ||
      CompanyNameErr ||
      PhoneErr ||
      DesignationErr ||
      MessageErr
    ) {
      this.setState({
        UsernameErr,
        PhoneErr,
        UseremailErr,
        CompanyNameErr,
        DesignationErr,
        MessageErr,
      });
      return false;
    }
    return true;
  };

  GetInTouchfun() {
    const isValid = this.validate();

    if (isValid) {
      this.setState({ ShowBar: true });

      const url =
        global.websiteUrl + "/service/KOL_landing/check_duplicate_get_in_touch";
      let formData = new FormData();
      formData.append("email_id", this.state.GetInTouchData.email_id);
      formData.append('token_id',this.state.pretoken);
   
      const config = {
        //   headers: { 'content-type': 'multipart/form-data' }
      };
      axios
        .post(url, formData, config)
        .then((response) => {
          console.log(response);
          var lgstatus = response.data.status;
          console.log("lgstatus", JSON.stringify(lgstatus));

          this.setState({ ShowBar: false });

          //  alert(lgstatus);

          if (lgstatus == false) {
            this.SaveGetInTouchDatafun();
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops",
              text: "Emails Already exits pls change new email",
              confirmButtonColor: "#d33",
              confirmButtonText: "OK",
            });

            this.setState({
              UseremailErr: "Change New Email",
              confirmpasswordErr: "",
              UsernameErr: "",
              CompanyNameErr: "",
              PasswordErr: "",
              termconditionErr: "",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  SaveGetInTouchDatafun() {
    this.setState({
      ShowBar: true,
    });

    const url =
      global.websiteUrl + "/service/KOL_landing/save_enqury";
    let formData = new FormData();

    formData.append(
      "enqury_info",
      JSON.stringify(this.state.GetInTouchData)
    );
    formData.append('token_id',this.state.pretoken);
   
    const config = {
      //   headers: { 'content-type': 'multipart/form-data' }
    };

    axios
      .post(url, formData, config)
      .then((response) => {
        console.log(response);
        var lgdata = response.data;
        console.log("lgdata", JSON.stringify(lgdata));
        var lgstatus = response.data.status;
        console.log("lgstatus", JSON.stringify(lgstatus));
        //      console.log("response message2", response.data.message)

        this.setState({
          ShowBar: false,
        });

        if (response.data.status == true) {
          Swal.fire({
            icon: "success",
            //text: response.data.message,
            text: "Success! Your message has been successfully delivered to us. Our team will get in touch with one working day.",
            confirmButtonColor: "#d33",
            confirmButtonText: "OK",
          });
        } else {
          Swal.fire({
            icon: "error",
            text: "Failed",
            confirmButtonColor: "#d33",
            confirmButtonText: "OK",
          });
        }

        setTimeout(function () {
          window.location.reload();
        }, 4000);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  submitKOLform() {
    this.setState({ kolFormSubmitted: true });
    if (this.state.selectedKol === this.state.kols[0].label) {
      if (this.state.clinicalKolForm.speciality) {
        sessionStorage.setItem("client_email", "");
        sessionStorage.setItem("client_id", "Guest");
        sessionStorage.setItem("client_name", "");
        sessionStorage.setItem(
          "subspeciality",
          this.state.clinicalKolForm.subSpeciality?.[0]?.label
        );
        sessionStorage.setItem(
          "procedure",
          this.state.clinicalKolForm.procedure?.[0]?.label
        );
        sessionStorage.setItem(
          "speciality_id",
          this.state.clinicalKolForm?.speciality?.[0]?.value
        );
        sessionStorage.setItem(
          "speciality",
          this.state.clinicalKolForm?.speciality?.[0]?.label
        );
        this.setState({ redirectPClientViewKolList: true });
      } else {
        Swal.fire({
          icon: "error",
          text: "Please Select Speciality",
          confirmButtonColor: "#d33",
          confirmButtonText: "OK",
        });
      }
    } else {
      if (this.state.nonClinicalKolForm.kolSubType) {
        console.log(this.state.nonClinicalKolForm.kolSubType)
        this.setState({
          showNonClinicalContactForm: true,
          searchModalOpen: false,
        });
      } else {
        Swal.fire({
          icon: "error",
          text: "Please Select KOL Subtype",
          confirmButtonColor: "#d33",
          confirmButtonText: "OK",
        });
      }
    }
  }

  handleClinicalFormField(id, value) {
    console.log({
      id,
      value,
    });
    let { clinicalKolForm } = this.state;
    // this.setState({
    //   ProcedureType: []
    // })
    if (id != '')
      clinicalKolForm[id] = value;

    clinicalKolForm['procedureType'] = this.state.Procedure
    clinicalKolForm['procedure'] = ""

    // const spId = this.state.SpecialityData.filter(sp => sp.speciality_type === value)[0]
    if (id == "speciality" && value?.[0]?.value !== undefined) {
      this.state.subClinicalKolEnabled = false
      this.setSubSpecility(value?.[0]?.value);
      this.state.profiletypeErr = false;

      // this.refs.typeahead.getInstance().clear()
      this.setState({
        ProcedureType: [],
        Procedure: false,
        procedureSelected: false,
        conditionSelected: false
      })
    } else if (id == "procedure" && value?.[0]?.value !== undefined) {
      this.state.subClinicalKolEnabled = false
    } else {
      this.state.subClinicalKolEnabled = true
    }
    this.setState({ clinicalKolForm: clinicalKolForm });
    console.log(this.state.clinicalKolForm);
  }

  handleNonClinicalFormField(id, value) {
    this.state.subClinicalKolEnabled = false
    let { nonClinicalKolForm } = this.state;
    nonClinicalKolForm[id] = value;
    this.setState({ nonClinicalKolForm: nonClinicalKolForm });
  }

  validateField(type, id) {
    console.log('Validate field called with - ', { type, id })
    const form = this.state[type];
    if (this.state.kolFormSubmitted) {
      if (form[id]) {
        console.log('returning false')
        return false;
      } else {
        console.log('returning true')
        return true;
      }
    } else {
      console.log('returning false')
      return false;
    }
  }

  validateContactFormField(id) {
    const form = this.state.nonClinicalKolForm;
    // console.log(this.state.nonClinicalContactFormSubmitted, "check");
    if (this.state.nonClinicalContactFormSubmitted) {
      if (form[id]) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  onProcedureChanged = (e) => {
    console.log(e.target.value);
    let { clinicalKolForm } = this.state
    console.log(clinicalKolForm)
    let speciality_id = clinicalKolForm.speciality
    if (!speciality_id) {
      this.state.profiletypeErr = 'Please select Speciality from dropdown!'
    }
    const value = e.target.value;
    this.setState({
      ProcedureType: [],
    });
    // console.log(this.refs.typeahead.clear())
    if (this.refs.typeahead) { this.refs.typeahead.clear() }
    value === "Procedure" ? this.setState({ procedureSelected: true, conditionSelected: false }) : this.setState({ conditionSelected: true, procedureSelected: false })
    const formdata = new FormData();
    if (speciality_id?.[0]) {
      formdata.append("speciality_type_id", speciality_id[0].value);
      this.setState({ Procedure: value });
      this.state.profiletypeErr = false

    }
    const options = {
      method: "POST",
      body: formdata,
    };
    let url =
      value === "Procedure"
        ? "/service/KOL_landing/Get_Procedure_List"
        : "/service/KOL_landing/Get_Condition_List";
    fetch(global.websiteUrl + url, options)
      .then((Response) => Response.json())
      .then((findresponse) => {
        console.log(findresponse);
        var procedureList = findresponse.data;
        if (procedureList != "undefined") {
          this.setState({
            ProcedureType: procedureList.map((item) => ({
              label:
                value === "Procedure"
                  ? item.procedure_type
                  : item.condition_type,
              value: item.id,
            })),
          });
        }
      });
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to={"/home"} />;
    }

    if (this.state.redirecthome) {
      return <Redirect to={"/home"} />;
    }

    if (this.state.redirectLogin) {
      return <Redirect to={"/user login"} />;
    }

    if (this.state.redirectSignup) {
      return <Redirect to={"/create new account"} />;
    }

    if (this.state.redirectPClientViewKolList) {
      return <Redirect to={"/PClientViewKolList"} />;
    }

    if (this.state.redirectAdmin) {
      return <Redirect to={"/AdminDashboard"} />;
    }

    if (this.state.redirectResercher) {
      return (
        <Redirect
          to={{
            pathname: "/ResercherDashboard",
            state: {
              RID: this.state.RID,
              resercher_name: this.state.resercher_name,
            },
          }}
        />
      );
    }

    if (this.state.redirectManager) {
      return (
        <Redirect
          to={{
            pathname: "/ManagerDashboard",
            // state:{manager_id: this.state.manager_id , manager_name: this.state.manager_name}
          }}
        />
      );
    }

    if (this.state.redirectEmployee) {
      return (
        <Redirect
          to={{
            pathname: "/EmployeeDashboard",
            //  state:{employee_id: this.state.employee_id , employee_name: this.state.employee_name}
          }}
        />
      );
    }

    if (this.state.redirectClientDashboard) {
      return (
        <Redirect
          to={{
            pathname: "/ClientViewProject",
          }}
        />
      );
    }

    if (this.state.redirectAdministratorDashboard) {
      return (
        <Redirect
          to={{
            pathname: "/AdministratorViewProject",
          }}
        />
      );
    }

    if (this.state.redirectVisitorDashboard) {
      return (
        <Redirect
          to={{
            pathname: "/VisitorDashboard",
          }}
        />
      );
    }

    if (this.state.redirectKolProfile) {
      return (
        <Redirect
          to={{
            pathname: "/KolProfileDashboard",
          }}
        />
      );
    }

    if (this.state.redirectTermsandPrivacy) {
      return (
        <Redirect
          to={{
            pathname: "/TermsPrivacyPolicy",
          }}
        />
      );
    }
    if (this.state.redirectKOLidentification) {
      return (
        <Redirect
          to={{
            pathname: "/kolidentification",
          }}
        />
      );
    }
    if (this.state.redirectKOLEngagement) {
      return (
        <Redirect
          to={{
            pathname: "/kolEngagement",
          }}
        />
      );
    }
    if (this.state.redirectabout) {
      return (
        <Redirect
          to={{
            pathname: "/about",
          }}
        />
      );
    }
    if (this.state.redirectpricing) {
      return (
        <Redirect
          to={{
            pathname: "/pricing",
          }}
        />
      );
    }
    if (this.state.redirectContact) {
      return (
        <Redirect
          to={{
            pathname: "/contact",
          }}
        />
      );
    }
    if (this.state.redirectBlogs) {
      return (
        <Redirect
          to={{
            pathname: "/blogs",
          }}
        />
      );
    }
    if (this.state.redirectCaseStudy) {
      return (
        <Redirect
          to={{
            pathname: "/casestudy",
          }}
        />
      );
    }
    if (this.state.redirectKOLCompliant) {
      return (
        <Redirect
          to={{
            pathname: "/compliant",
          }}
        />
      );
    }
    let speciality_type = this.state.SpecialityData;
    let OptionsSpeciality = speciality_type.map((speciality_type) => (
      <option key={speciality_type.id} value={speciality_type.id}>
        {speciality_type.speciality_type}
      </option>
    ));

    return (
      <body id="landing-body">
        <div>
          {this.state.ShowBar ? (
            <Modal isOpen={true} className="propagateLoader" centered>
              <PropagateLoader color={"#A90007"} size="40px" loading="true" />
            </Modal>
          ) : null}
        </div>
        {this.state.ShowProcedure ? (
          <Modal isOpen={true} className="propagateLoader" centered>
            <PropagateLoader color={"#A90007"} size="40px" loading="true" />
          </Modal>
        ) : null}

        {AddLibrary("./js/app.js")}

        <nav
          className="navbar navbar-expand-lg navbar-landing sticky-top" id="navbar"
        >
          <div className="content container-fluid">
            <a
              className="navbar-brand"
              href="https://www.medtech-gurus.com"
            >
              <img
                src={require('../src/Assets/Images/Medtech_Gurus_logo.png')}
                width="100"
              ></img>
            </a>
            <div className="menu-bar">
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <i className="bx bx-menu"></i>
              </button>
              <div
                className="navbar-collapse collapse"
                id="navbarNav">
                <ul className="navbar-nav me-md-auto ms-auto mt-2 mt-lg-0">
                <li className="nav-item">
                    <a
                      href='/home' onClick={this.redirecthome}
                      className="nav-link"
                    >
                      Home
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href='/about us' onClick={this.redirectabout}
                    >
                      About Us
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href='/kol identification' onClick={this.redirectKOLidentification}
                    >
                      KOL Identification
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href='/kol engagement' onClick={this.redirectKOLEngagement}
                    >
                      KOL Engagement
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href='/pricing' onClick={this.redirectpricing}
                    >
                      Pricing
                    </a>
                  </li>                  
                  <li className="nav-item">
                  <a
                      className="nav-link"
                      href='/blogs' onClick={this.redirectBlogs}
                    >
                      Blogs
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href='/contact us' onClick={this.redirectContact}
                    >
                      Contact Us
                    </a>
                  </li>
                  <li className="nav-signup align-items-center d-flex d-lg-none">
                    <a
                      href="javascript:void(0);"
                      style={{ color: "#A90007", fontWeight: "bolder" }}
                      data-bs-toggle="modal"
                      onClick={this.toggleLoginModal.bind(this)}
                    >
                      Log In
                    </a>
                    <a
                      href="javascript:void(0);"
                      style={{ color: "#A90007", fontWeight: "bolder" }}
                      data-bs-toggle="modal"
                      onClick={this.toggleSignUpModal.bind(this)}
                    >
                      / Sign Up
                    </a>
                  </li>
                </ul>

              </div>
            </div>
            <div className="Navheaderlink justify-content-between d-none d-lg-flex">
              <ul className="navbar-nav  align-items-center gap-20">
                <li className="nav-social">
                  <a
                    href="https://www.linkedin.com/company/cetas-healthcare/"
                    target="_blank"
                  >
                    <i className="bx bxl-linkedin"></i>
                  </a>
                </li>
                <li className="nav-social">
                  <a
                    onClick={this.makespaceondivhome.bind(this)}
                    href="mailto:kolmanagement@cetas-healthcare.com"
                    style={{ fontWeight: "normal" }}
                  >
                    <i className="bx bx-envelope"></i>
                    {/* <img src="./static/media/email.f2b82b84.svg" /> */}
                    {/* kolmanagement@cetas-healthcare.com */}
                  </a>
                </li>
              </ul>

              <div className="nav-signup align-items-center">
                <a
                  href="javascript:void(0);"
                  style={{ color: "#A90007", fontWeight: "bolder" }}
                  data-bs-toggle="modal"
                  onClick={this.toggleLoginModal.bind(this)}
                >
                  Log In
                </a>
                <a
                  href="javascript:void(0);"
                  style={{ color: "#A90007", fontWeight: "bolder" }}
                  data-bs-toggle="modal"
                  onClick={this.toggleSignUpModal.bind(this)}
                >
                  / Sign Up
                </a>
              </div>
            </div>
          </div>
        </nav>
        <div id="page-banner" className="bg-service">
          <div className="bg-overlay"></div>
          <div className="container-fluid banner-section">
            <h1 className="pb-1 text-white">KOL Identification</h1>
            <ol class="breadcrumb m-0 p-0 bg-transparent">
              <li class="breadcrumb-item"><a href="/home">Home</a></li>
              <li class="breadcrumb-item active">KOL Identification</li>
            </ol>
          </div>
        </div>
        <section class="section">
          <div class="container">
            <div class="justify-content-center row">
              <div class="col-lg-12">
                <div class="mb-4">
                  <h2 class="mb-3 fs-4 fw-bold lh-base text-start">Key Opinion Leader Profiling Platform for the Medical Device Industry</h2>
                  <p class="text-justify">For the first time, here is an Expert Network platform specifically for the MedTech industry! An Expert Network of not just Healthcare KOLs, but also HTA Experts, Payers, Hospital Procurement Experts, Advocacy Group Experts, and MedTech Industry Experts. Our platform is the only one-stop-solution to find the most relevant KOLs Medical Experts for any of your MedTech requirements. Cetas can help you to identify, and profile with any of these experts.</p>
                </div>
              </div>
            </div>
            <div class="justify-content-center row d-none">
              <div class="col-lg-12">
                <div class="text-start mb-4">
                  <h3 class="mb-0 fw-bold lh-base fs-4">Medtech Guru Platform Offerings</h3>
                </div>
              </div>
            </div>
            <div class="justify-content-center row  d-none">
              <div class="col-10">
                <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 1092.72 573.32">
                  <title>Medtech Guru Platform Offerings</title>
                  <path class="cls-1" d="M567.22,626.51a42.71,42.71,0,1,1-42.71-42.71A42.71,42.71,0,0,1,567.22,626.51Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-1" d="M470.18,517.16a42.72,42.72,0,1,1-42.72-42.71A42.72,42.72,0,0,1,470.18,517.16Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-1" d="M394.76,398A42.72,42.72,0,1,1,352,355.29,42.72,42.72,0,0,1,394.76,398Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-1" d="M470.17,279.77a42.71,42.71,0,1,1-42.71-42.71A42.71,42.71,0,0,1,470.17,279.77Z" transform="translate(-122.78 -109.01)"></path>
                  <circle class="cls-1" cx="525.91" cy="164.83" r="42.71" transform="translate(109.45 522.19) rotate(-75.2)"></circle>
                  <path class="cls-1" d="M713,164.83a42.71,42.71,0,1,1,42.71,42.71A42.72,42.72,0,0,1,713,164.83Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-1" d="M815.28,279.77A42.71,42.71,0,1,1,858,322.48,42.71,42.71,0,0,1,815.28,279.77Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-1" d="M887.78,399.81a42.72,42.72,0,1,1,42.72,42.71A42.72,42.72,0,0,1,887.78,399.81Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-1" d="M815.31,517.1A42.71,42.71,0,1,1,858,559.81,42.72,42.72,0,0,1,815.31,517.1Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-1" d="M708.54,626.51a42.71,42.71,0,1,1,42.71,42.71A42.71,42.71,0,0,1,708.54,626.51Z" transform="translate(-122.78 -109.01)"></path>
                  <path d="M523.12,220.64H523l-.25,0A2.3,2.3,0,1,1,523,216h.2a2.31,2.31,0,0,1-.11,4.61Zm10.59-.52a2.31,2.31,0,0,1-.34-4.59l.23,0a2.31,2.31,0,0,1,.68,4.56l-.22,0A2.07,2.07,0,0,1,533.71,220.12Zm-21.3-1.1a2.22,2.22,0,0,1-.57-.07l-.24-.06a2.31,2.31,0,1,1,1.18-4.46l.2,0a2.31,2.31,0,0,1-.57,4.54Zm31.8-1.57a2.31,2.31,0,0,1-.8-4.47l.22-.08a2.31,2.31,0,1,1,1.59,4.33l-.2.07A2.32,2.32,0,0,1,544.21,217.45Zm-42-2.18a2.21,2.21,0,0,1-1-.24l-.2-.1a2.3,2.3,0,1,1,2-4.13l.21.1a2.31,2.31,0,0,1-1,4.37ZM554,212.65a2.31,2.31,0,0,1-2-1.07,2.25,2.25,0,0,1,.69-3.14l.2-.12a2.3,2.3,0,1,1,2.44,3.91l-.1.07A2.4,2.4,0,0,1,554,212.65Zm-61-3.11a2.27,2.27,0,0,1-1.41-.48l-.18-.14a2.31,2.31,0,1,1,2.83-3.64l.18.14a2.3,2.3,0,0,1-1.42,4.12Zm69.51-3.45a2.3,2.3,0,0,1-1.59-4l.15-.15a2.31,2.31,0,1,1,3.19,3.33l-.16.16A2.32,2.32,0,0,1,562.55,206.09Zm-77.37-4a2.32,2.32,0,0,1-1.74-.79l-.08-.1a2.35,2.35,0,0,1,.2-3.29,2.27,2.27,0,0,1,3.22.19l.14.17a2.31,2.31,0,0,1-.22,3.26A2.36,2.36,0,0,1,485.18,202.09Zm84.45-4.18a2.27,2.27,0,0,1-1.33-.43,2.32,2.32,0,0,1-.55-3.22l.12-.17a2.31,2.31,0,0,1,3.79,2.65l-.15.2A2.31,2.31,0,0,1,569.63,197.91ZM479,193.21a2.28,2.28,0,0,1-2-1.18l-.12-.22a2.31,2.31,0,0,1,4.05-2.21l.1.18a2.3,2.3,0,0,1-.9,3.14A2.26,2.26,0,0,1,479,193.21Zm96-4.75a2.31,2.31,0,0,1-2.12-3.23l.09-.2a2.31,2.31,0,0,1,4.24,1.82l-.1.22A2.3,2.3,0,0,1,574.94,188.46Zm-100.26-5.19a2.31,2.31,0,0,1-2.2-1.62l-.07-.22a2.3,2.3,0,1,1,4.4-1.37l.07.21a2.31,2.31,0,0,1-1.51,2.89A2.37,2.37,0,0,1,474.68,183.27Zm103.54-5.14a2.18,2.18,0,0,1-.5,0,2.31,2.31,0,0,1-1.75-2.75l0-.18a2.31,2.31,0,1,1,4.52.91l-.06.27A2.31,2.31,0,0,1,578.22,178.13Zm-105.74-5.47a2.31,2.31,0,0,1-2.29-2.08l0-.23a2.31,2.31,0,1,1,4.59-.45l0,.22a2.31,2.31,0,0,1-2.07,2.53Zm106.87-5.3h0A2.31,2.31,0,0,1,577,165v-.43a2.31,2.31,0,0,1,4.62,0v.47A2.32,2.32,0,0,1,579.35,167.36Zm-106.88-5.54h-.23a2.3,2.3,0,0,1-2.07-2.52l0-.25a2.31,2.31,0,0,1,4.59.5l0,.21A2.3,2.3,0,0,1,472.47,161.82Zm105.8-5.46a2.31,2.31,0,0,1-2.26-1.85l0-.2a2.31,2.31,0,1,1,4.51-1l0,.24a2.33,2.33,0,0,1-2.26,2.77Zm-103.66-5.15a2.35,2.35,0,0,1-.68-.11,2.29,2.29,0,0,1-1.52-2.88l.07-.24a2.31,2.31,0,1,1,4.4,1.4l-.06.2A2.32,2.32,0,0,1,474.61,151.21ZM575,146a2.31,2.31,0,0,1-2.13-1.42l-.07-.18a2.31,2.31,0,0,1,4.23-1.84l.1.24A2.31,2.31,0,0,1,575,146Zm-96.17-4.78a2.3,2.3,0,0,1-2-3.42l.13-.23a2.31,2.31,0,0,1,4,2.28l-.09.18A2.31,2.31,0,0,1,478.86,141.24Zm90.91-4.69a2.29,2.29,0,0,1-1.89-1l-.13-.18a2.31,2.31,0,0,1,3.78-2.65l.13.2a2.3,2.3,0,0,1-1.89,3.62ZM485,132.34a2.31,2.31,0,0,1-1.75-3.81l.14-.16a2.3,2.3,0,1,1,3.52,3l-.16.19A2.3,2.3,0,0,1,485,132.34Zm77.6-4a2.18,2.18,0,0,1-1.5-.59l-.12-.12a2.34,2.34,0,0,1-.12-3.29,2.27,2.27,0,0,1,3.23-.11l.06,0a2.33,2.33,0,0,1-1.55,4.06Zm-69.76-3.45a2.31,2.31,0,0,1-1.42-4.13l.17-.13a2.31,2.31,0,0,1,2.85,3.63l-.19.15A2.33,2.33,0,0,1,492.88,124.85Zm61.27-3.17a2.27,2.27,0,0,1-1.22-.35l-.18-.11a2.31,2.31,0,0,1,2.42-3.93l.21.13a2.31,2.31,0,0,1-1.23,4.26Zm-52.1-2.59a2.31,2.31,0,0,1-1-4.37l.23-.12a2.31,2.31,0,0,1,2,4.16l-.18.08A2.24,2.24,0,0,1,502.05,119.09Zm42.38-2.19a2.36,2.36,0,0,1-.81-.15l-.2-.07a2.31,2.31,0,0,1,1.6-4.33l.23.08a2.31,2.31,0,0,1-.82,4.47Zm-32.24-1.6a2.31,2.31,0,0,1-.59-4.54l.2-.05a2.31,2.31,0,1,1,1.19,4.46l-.2,0A2.47,2.47,0,0,1,512.19,115.3ZM534,114.18l-.37,0-.2,0a2.31,2.31,0,0,1-1.94-2.63,2.29,2.29,0,0,1,2.62-1.93l.25,0a2.31,2.31,0,0,1-.36,4.59Zm-11.05-.55a2.31,2.31,0,0,1-.11-4.61H523a2.31,2.31,0,1,1,.23,4.61h-.34Z" transform="translate(-122.78 -109.01)"></path>
                  <path d="M424.68,335.58h-.37a2.31,2.31,0,0,1,.28-4.61h.2a2.31,2.31,0,0,1-.11,4.61Zm10.59-.52a2.31,2.31,0,0,1-.34-4.59l.22,0a2.31,2.31,0,1,1,.69,4.56l-.23,0ZM414,334a2.24,2.24,0,0,1-.57-.08l-.25-.06a2.31,2.31,0,0,1,1.19-4.46l.2.05A2.31,2.31,0,0,1,414,334Zm31.8-1.58a2.31,2.31,0,0,1-.8-4.47l.22-.08a2.31,2.31,0,0,1,1.59,4.33l-.2.07A2.32,2.32,0,0,1,445.77,332.39Zm-42-2.17a2.34,2.34,0,0,1-1-.24l-.21-.11a2.31,2.31,0,0,1,2.05-4.13l.2.1a2.31,2.31,0,0,1-1,4.38Zm51.77-2.63a2.3,2.3,0,0,1-2-1.06,2.27,2.27,0,0,1,.69-3.15l.19-.12a2.31,2.31,0,1,1,2.44,3.92l-.1.06A2.34,2.34,0,0,1,455.57,327.59Zm-61-3.1a2.28,2.28,0,0,1-1.41-.49l-.18-.14a2.31,2.31,0,1,1,2.83-3.64l.18.14a2.31,2.31,0,0,1-1.42,4.13ZM464.1,321a2.31,2.31,0,0,1-1.59-4l.16-.15a2.31,2.31,0,1,1,3.19,3.33l-.17.16A2.27,2.27,0,0,1,464.1,321Zm-77.36-4a2.31,2.31,0,0,1-1.74-.79l-.08-.09a2.37,2.37,0,0,1,.2-3.3,2.26,2.26,0,0,1,3.21.19l.15.17a2.31,2.31,0,0,1-.23,3.26A2.26,2.26,0,0,1,386.74,317Zm84.45-4.18a2.31,2.31,0,0,1-1.88-3.64l.12-.18a2.31,2.31,0,0,1,3.78,2.65l-.14.2A2.31,2.31,0,0,1,471.19,312.85Zm-90.66-4.69a2.31,2.31,0,0,1-2-1.19l-.12-.22a2.3,2.3,0,1,1,4.05-2.2l.1.18a2.32,2.32,0,0,1-2,3.43Zm96-4.76a2.33,2.33,0,0,1-.92-.19,2.31,2.31,0,0,1-1.19-3l.09-.2a2.3,2.3,0,1,1,4.23,1.82l-.09.23A2.32,2.32,0,0,1,476.49,303.4Zm-100.26-5.19a2.31,2.31,0,0,1-2.2-1.62l-.07-.22a2.31,2.31,0,0,1,4.41-1.37l.07.22a2.3,2.3,0,0,1-1.52,2.88A2.07,2.07,0,0,1,376.23,298.21Zm103.55-5.13a2.07,2.07,0,0,1-.5-.06,2.31,2.31,0,0,1-1.76-2.75l0-.18a2.31,2.31,0,1,1,4.52.91l-.05.27A2.32,2.32,0,0,1,479.78,293.08ZM374,287.6a2.31,2.31,0,0,1-2.29-2.08l0-.22a2.31,2.31,0,0,1,4.6-.46l0,.23a2.31,2.31,0,0,1-2.07,2.52Zm106.87-5.3h0A2.3,2.3,0,0,1,478.6,280v-.43a2.31,2.31,0,0,1,4.61,0V280A2.3,2.3,0,0,1,480.91,282.3ZM374,276.77h-.23a2.31,2.31,0,0,1-2.06-2.53l0-.25a2.31,2.31,0,0,1,4.59.51l0,.2A2.31,2.31,0,0,1,374,276.77Zm105.8-5.47a2.31,2.31,0,0,1-2.26-1.85l0-.2a2.31,2.31,0,0,1,4.52-1l0,.25a2.32,2.32,0,0,1-1.81,2.72A2.38,2.38,0,0,1,479.82,271.3Zm-103.65-5.15a2.24,2.24,0,0,1-.68-.1,2.32,2.32,0,0,1-1.53-2.89l.08-.24a2.31,2.31,0,0,1,4.39,1.41l-.06.19A2.31,2.31,0,0,1,376.17,266.15ZM476.59,261a2.31,2.31,0,0,1-2.13-1.41l-.08-.18a2.31,2.31,0,1,1,4.23-1.84l.1.23a2.3,2.3,0,0,1-2.12,3.2Zm-96.17-4.78a2.3,2.3,0,0,1-2-3.42l.13-.22a2.31,2.31,0,1,1,4,2.28l-.1.17A2.31,2.31,0,0,1,380.42,256.18Zm90.91-4.69a2.3,2.3,0,0,1-1.9-1l-.12-.18a2.31,2.31,0,1,1,3.78-2.64l.13.19a2.3,2.3,0,0,1-.58,3.21A2.28,2.28,0,0,1,471.33,251.49Zm-84.73-4.21a2.26,2.26,0,0,1-1.5-.56,2.3,2.3,0,0,1-.25-3.25l.13-.16a2.31,2.31,0,0,1,3.53,3l-.16.18A2.28,2.28,0,0,1,386.6,247.28Zm77.6-4a2.19,2.19,0,0,1-1.5-.6l-.13-.12a2.33,2.33,0,0,1-.11-3.28,2.27,2.27,0,0,1,3.23-.12l.06.06a2.34,2.34,0,0,1-1.55,4.06Zm-69.77-3.46a2.27,2.27,0,0,1-1.82-.89,2.31,2.31,0,0,1,.41-3.24l.17-.13a2.3,2.3,0,0,1,2.84,3.63l-.19.15A2.25,2.25,0,0,1,394.43,239.79Zm61.28-3.16a2.28,2.28,0,0,1-1.22-.36l-.18-.11a2.31,2.31,0,1,1,2.42-3.93l.21.14a2.31,2.31,0,0,1-1.23,4.26Zm-52.1-2.6a2.31,2.31,0,0,1-1-4.37l.23-.11a2.31,2.31,0,1,1,2,4.15l-.17.09A2.39,2.39,0,0,1,403.61,234ZM446,231.84a2.32,2.32,0,0,1-.81-.15l-.2-.07a2.31,2.31,0,0,1,1.59-4.33l.23.08a2.31,2.31,0,0,1-.81,4.47Zm-32.24-1.6a2.31,2.31,0,0,1-.59-4.54l.19,0a2.33,2.33,0,0,1,2.83,1.65,2.29,2.29,0,0,1-1.63,2.81l-.21,0A2.33,2.33,0,0,1,413.75,230.24Zm21.76-1.12a2.31,2.31,0,0,1-.37,0l-.2,0a2.31,2.31,0,1,1,.68-4.56l.25,0a2.3,2.3,0,0,1-.36,4.58Zm-11.05-.54a2.31,2.31,0,0,1-.12-4.61l.23,0a2.31,2.31,0,0,1,.23,4.61h-.34Z" transform="translate(-122.78 -109.01)"></path>
                  <path d="M349.94,455.38h-.32a2.32,2.32,0,0,1-2.21-2.4,2.28,2.28,0,0,1,2.39-2.22H350a2.31,2.31,0,0,1-.09,4.62Zm10.58-.65a2.31,2.31,0,0,1-.41-4.58l.28,0a2.3,2.3,0,1,1,.72,4.55l-.17,0A2,2,0,0,1,360.52,454.73Zm-21.31-.84a2.08,2.08,0,0,1-.55-.07l-.22-.05a2.31,2.31,0,1,1,1.09-4.48l.23,0a2.31,2.31,0,0,1-.55,4.55Zm31.78-2a2.31,2.31,0,0,1-.82-4.47l.21-.07a2.3,2.3,0,1,1,1.65,4.3l-.22.09A2.37,2.37,0,0,1,371,451.93Zm-42-1.67a2.33,2.33,0,0,1-1-.22l0,0a2.37,2.37,0,0,1-1.21-3.09,2.24,2.24,0,0,1,3-1.17l.21.1a2.32,2.32,0,0,1,1.1,3.08A2.29,2.29,0,0,1,329,450.26Zm51.69-3.19a2.31,2.31,0,0,1-1.28-4.23l.23-.15a2.31,2.31,0,0,1,2.47,3.9l-.15.09A2.28,2.28,0,0,1,380.68,447.07Zm-60.95-2.42a2.26,2.26,0,0,1-1.37-.46l-.13-.09a2.35,2.35,0,0,1-.49-3.26,2.28,2.28,0,0,1,3.19-.48l-1.31,1.9,1.48-1.77a2.31,2.31,0,0,1-1.37,4.16Zm69.45-4.29a2.31,2.31,0,0,1-1.62-3.95l.18-.17a2.31,2.31,0,1,1,3.21,3.31l-.15.14A2.27,2.27,0,0,1,389.18,440.36Zm-77.4-3.07a2.31,2.31,0,0,1-1.73-.78l-.15-.17a2.31,2.31,0,1,1,3.46-3l.15.17a2.31,2.31,0,0,1-1.73,3.83Zm84.39-5.21a2.31,2.31,0,0,1-1.9-3.61l.12-.18a2.31,2.31,0,0,1,3.82,2.59l-.14.21A2.33,2.33,0,0,1,396.17,432.08Zm-90.71-3.59a2.32,2.32,0,0,1-2-1.17l-.1-.18a2.31,2.31,0,0,1,4-2.32l.13.22a2.31,2.31,0,0,1-2,3.45Zm95.9-5.92a2.37,2.37,0,0,1-.9-.18,2.31,2.31,0,0,1-1.22-3l.08-.19a2.31,2.31,0,1,1,4.26,1.77l-.1.23A2.29,2.29,0,0,1,401.36,422.57Zm-100.31-4a2.31,2.31,0,0,1-2.19-1.57l-.08-.24a2.31,2.31,0,1,1,4.39-1.42l.06.2a2.31,2.31,0,0,1-1.46,2.92A2.25,2.25,0,0,1,301.05,418.59Zm103.47-6.39a2.38,2.38,0,0,1-.46,0,2.31,2.31,0,0,1-1.8-2.72l0-.2a2.31,2.31,0,0,1,4.53.86l-.05.26A2.32,2.32,0,0,1,404.52,412.2ZM298.72,408a2.32,2.32,0,0,1-2.29-2l0-.25a2.3,2.3,0,0,1,4.58-.5l0,.2a2.32,2.32,0,0,1-2,2.57Zm106.8-6.59a2.31,2.31,0,0,1-2.31-2.29v-.23a2.4,2.4,0,0,1,2.27-2.43,2.25,2.25,0,0,1,2.34,2.15v.47a2.31,2.31,0,0,1-2.28,2.33Zm-106.95-4.24h-.21a2.31,2.31,0,0,1-2.09-2.5l0-.23a2.31,2.31,0,0,1,4.6.41l0,.23A2.31,2.31,0,0,1,298.57,397.18Zm105.73-6.75A2.31,2.31,0,0,1,402,388.6l0-.19a2.31,2.31,0,1,1,4.5-1l.06.25a2.31,2.31,0,0,1-1.78,2.73A2,2,0,0,1,404.3,390.43Zm-103.71-3.89a2.05,2.05,0,0,1-.65-.1,2.3,2.3,0,0,1-1.56-2.87l.07-.25a2.31,2.31,0,0,1,4.41,1.38l-.06.18A2.29,2.29,0,0,1,300.59,386.54Zm100.35-6.41a2.29,2.29,0,0,1-2.1-1.36l-.1-.21a2.31,2.31,0,1,1,4.21-1.88l.09.2a2.3,2.3,0,0,1-2.1,3.25Zm-96.22-3.61a2.27,2.27,0,0,1-1.09-.28,2.31,2.31,0,0,1-.94-3.12l.12-.21a2.3,2.3,0,0,1,4.05,2.2l-.11.2A2.3,2.3,0,0,1,304.72,376.52Zm90.85-5.79a2.31,2.31,0,0,1-1.88-1l-.13-.17a2.31,2.31,0,0,1,3.75-2.7l.13.19a2.3,2.3,0,0,1-1.87,3.65Zm-84.78-3.19a2.3,2.3,0,0,1-1.77-3.78l.14-.17a2.31,2.31,0,0,1,3.55,3l-.15.17A2.28,2.28,0,0,1,310.79,367.54Zm77.55-5a2.18,2.18,0,0,1-1.48-.58l-.12-.11a2.32,2.32,0,0,1-.16-3.28,2.27,2.27,0,0,1,3.23-.17l.06.06a2.34,2.34,0,0,1-1.53,4.08ZM318.53,360a2.31,2.31,0,0,1-1.44-4.11l.18-.14a2.31,2.31,0,0,1,2.88,3.61l-.18.14A2.27,2.27,0,0,1,318.53,360Zm61.24-3.91a2.27,2.27,0,0,1-1.22-.35l-.16-.09a2.31,2.31,0,0,1,2.37-4l.24.14a2.31,2.31,0,0,1-1.23,4.26Zm-52.13-2a2.31,2.31,0,0,1-1.05-4.36l.22-.12a2.31,2.31,0,0,1,2.05,4.14l-.18.08A2.17,2.17,0,0,1,327.64,354.09Zm42.35-2.7a2.28,2.28,0,0,1-.77-.14l-.21-.07a2.31,2.31,0,1,1,1.54-4.35l.22.08a2.31,2.31,0,0,1-.78,4.48Zm-32.25-1.22a2.31,2.31,0,0,1-.62-4.53l.26-.07a2.31,2.31,0,1,1,1.15,4.47l-.17,0A2.25,2.25,0,0,1,337.74,350.17Zm21.74-1.38a1.67,1.67,0,0,1-.32,0l-.23,0a2.31,2.31,0,1,1,.64-4.57l.22,0a2.31,2.31,0,0,1-.31,4.59Zm-11.06-.41a2.31,2.31,0,0,1-.16-4.61h.24a2.3,2.3,0,0,1,.29,4.6l-.21,0Z" transform="translate(-122.78 -109.01)"></path>
                  <g class="cls-22">
                    <path d="M756.68,220.63a2.31,2.31,0,0,1,0-4.62h.27a2.31,2.31,0,0,1,.05,4.61h-.28Zm-10.57-.85a2,2,0,0,1-.41,0l-.25-.05a2.3,2.3,0,1,1,.88-4.52l.19,0a2.31,2.31,0,0,1-.41,4.58Zm21.33-.44a2.31,2.31,0,0,1-.49-4.56l.21-.05a2.31,2.31,0,1,1,1,4.5l-.23.06A2.92,2.92,0,0,1,767.44,219.34Zm-31.74-2.57a2.16,2.16,0,0,1-.86-.17l-.23-.09a2.3,2.3,0,1,1,1.76-4.26l.2.07a2.31,2.31,0,0,1-.87,4.45Zm42-.85a2.31,2.31,0,0,1-.94-4.42l.19-.08a2.31,2.31,0,0,1,1.92,4.2l-.23.1A2.21,2.21,0,0,1,777.72,215.92Zm-51.61-4.2a2.34,2.34,0,0,1-1.28-.39l-.2-.14a2.3,2.3,0,0,1,2.59-3.81l.17.11a2.31,2.31,0,0,1-1.28,4.23Zm61-1.23a2.31,2.31,0,0,1-1.37-4.17l.2-.15a2.31,2.31,0,0,1,2.7,3.75l-.16.11A2.3,2.3,0,0,1,787.1,210.49Zm-69.36-5.64a2.31,2.31,0,0,1-1.64-.68l-.17-.17a2.31,2.31,0,0,1,3.29-3.24l.15.15a2.31,2.31,0,0,1-1.63,3.94Zm77.45-1.57a2.3,2.3,0,0,1-1.7-3.87l.14-.15a2.3,2.3,0,0,1,3.42,3.09l-.17.18A2.26,2.26,0,0,1,795.19,203.28Zm-84.29-6.84a2.31,2.31,0,0,1-1.92-1l-.15-.23a2.3,2.3,0,1,1,3.89-2.47l.1.14a2.3,2.3,0,0,1-.64,3.2A2.24,2.24,0,0,1,710.9,196.44Zm90.77-1.84a2.31,2.31,0,0,1-2-3.49l.12-.2a2.31,2.31,0,0,1,4,2.37l-.12.2A2.31,2.31,0,0,1,801.67,194.6Zm-95.76-7.77a2.29,2.29,0,0,1-2.14-1.44l-.1-.25a2.3,2.3,0,1,1,4.3-1.65l.07.17a2.3,2.3,0,0,1-1.27,3A2.2,2.2,0,0,1,705.91,186.83Zm100.37-2a2.31,2.31,0,0,1-2.19-3l.09-.26a2.31,2.31,0,0,1,4.35,1.54l-.06.18A2.31,2.31,0,0,1,806.28,184.79ZM703,176.41a2.33,2.33,0,0,1-2.27-1.9l0-.27a2.3,2.3,0,0,1,4.55-.74l0,.19a2.32,2.32,0,0,1-1.87,2.68A2.71,2.71,0,0,1,703,176.41Zm105.86-2.15-.27,0a2.3,2.3,0,0,1-2-2.56l0-.28a2.3,2.3,0,1,1,4.56.64l0,.18A2.32,2.32,0,0,1,808.81,174.26ZM702.16,165.6h0a2.31,2.31,0,0,1-2.26-2.35V163a2.31,2.31,0,0,1,4.61.19v.18A2.3,2.3,0,0,1,702.16,165.6Zm107-2.17a2.31,2.31,0,0,1-2.3-2.17l0-.42a2.3,2.3,0,0,1,4.6-.3l0,.44a2.3,2.3,0,0,1-2.16,2.44Zm-105.62-8.58a2.57,2.57,0,0,1-.55-.06,2.31,2.31,0,0,1-1.7-2.79l.05-.18a2.3,2.3,0,1,1,4.5,1l-.06.27A2.31,2.31,0,0,1,703.54,154.85Zm103.75-2.3a2.3,2.3,0,0,1-2.21-1.67l-.06-.22a2.31,2.31,0,0,1,4.43-1.28l.06.23a2.31,2.31,0,0,1-1.58,2.85A2.35,2.35,0,0,1,807.29,152.55Zm-100.23-7.94a2.38,2.38,0,0,1-1-.21,2.31,2.31,0,0,1-1.14-3.06l.12-.24a2.31,2.31,0,1,1,4.16,2l-.08.17A2.32,2.32,0,0,1,707.06,144.61Zm96.27-2.14a2.29,2.29,0,0,1-2-1.22l-.12-.23a2.31,2.31,0,1,1,4.1-2.12l.09.18a2.31,2.31,0,0,1-1,3.12A2.37,2.37,0,0,1,803.33,142.47Zm-90.75-7.19a2.3,2.3,0,0,1-1.85-3.68l.13-.17a2.3,2.3,0,1,1,3.72,2.72l-.14.2A2.32,2.32,0,0,1,712.58,135.28Zm84.82-1.88a2.29,2.29,0,0,1-1.79-.85l-.14-.17a2.31,2.31,0,0,1,3.57-2.93l.15.19a2.3,2.3,0,0,1-1.79,3.76Zm-77.54-6.15a2.3,2.3,0,0,1-1.56-4,.94.94,0,0,1,.1-.1,2.36,2.36,0,0,1,3.29.13,2.25,2.25,0,0,1-.1,3.21l-.17.15A2.28,2.28,0,0,1,719.86,127.25Zm69.91-1.54a2.25,2.25,0,0,1-1.46-.53l-.18-.14a2.31,2.31,0,1,1,2.93-3.57l.17.15a2.31,2.31,0,0,1-1.46,4.09Zm-61.18-4.87a2.31,2.31,0,0,1-1.17-4.29l.23-.13a2.31,2.31,0,0,1,2.28,4l-.16.09A2.28,2.28,0,0,1,728.59,120.84Zm52.17-1.15a2.26,2.26,0,0,1-1.09-.27l-.18-.09a2.31,2.31,0,1,1,2.13-4.09l.22.11a2.31,2.31,0,0,1-1.08,4.34Zm-42.32-3.36a2.31,2.31,0,0,1-.75-4.49l.24-.07a2.3,2.3,0,1,1,1.46,4.37l-.2.07A2.4,2.4,0,0,1,738.44,116.33Zm32.28-.71a2.22,2.22,0,0,1-.67-.1l-.19-.06a2.3,2.3,0,1,1,1.27-4.43l.25.07a2.31,2.31,0,0,1-.66,4.52ZM749,113.91a2.31,2.31,0,0,1-.3-4.6l.25,0a2.31,2.31,0,1,1,.55,4.58l-.2,0Zm11.06-.25h-.18l-.23,0a2.31,2.31,0,0,1-2.12-2.48A2.33,2.33,0,0,1,760,109l.22,0a2.31,2.31,0,0,1-.18,4.61Z" transform="translate(-122.78 -109.01)"></path>
                  </g>
                  <g class="cls-3">
                    <path d="M861.45,335.58a2.31,2.31,0,0,1-.14-4.61h.2a2.31,2.31,0,1,1,.33,4.6l-.26,0Zm-10.6-.39a1.83,1.83,0,0,1-.33,0l-.22,0a2.31,2.31,0,0,1,.64-4.57l.22,0a2.31,2.31,0,0,1-.31,4.59Zm21.28-1.37a2.31,2.31,0,0,1-.6-4.53l.21-.06a2.31,2.31,0,1,1,1.23,4.45l-.23.06A2.13,2.13,0,0,1,872.13,333.82Zm-31.82-1.15a2.46,2.46,0,0,1-.75-.13l-.25-.09a2.31,2.31,0,0,1,1.57-4.34l.18.07a2.29,2.29,0,0,1,1.43,2.93A2.32,2.32,0,0,1,840.31,332.67Zm41.94-2.74a2.31,2.31,0,0,1-1-4.37l.18-.09a2.3,2.3,0,1,1,2.1,4.1l-.22.12A2.35,2.35,0,0,1,882.25,329.93Zm-51.75-1.88a2.23,2.23,0,0,1-1.19-.33l-.21-.13a2.31,2.31,0,0,1,2.41-3.93l.19.11a2.31,2.31,0,0,1-1.2,4.28Zm60.91-4a2.29,2.29,0,0,1-1.49-4l.18-.14a2.31,2.31,0,0,1,2.9,3.59l-.1.08A2.39,2.39,0,0,1,891.41,324Zm-69.58-2.47a2.31,2.31,0,0,1-1.57-.62l-.14-.12a2.31,2.31,0,0,1,3.08-3.44l.2.18a2.31,2.31,0,0,1-1.57,4Zm77.31-5a2.28,2.28,0,0,1-1.5-.55,2.31,2.31,0,0,1-.25-3.26l.11-.13a2.31,2.31,0,0,1,3.57,2.92l-.18.22A2.3,2.3,0,0,1,899.14,316.53Zm-84.5-3.07a2.33,2.33,0,0,1-1.87-.95,1.05,1.05,0,0,1-.07-.11,2.36,2.36,0,0,1,.48-3.26,2.27,2.27,0,0,1,3.18.46l.14.19a2.31,2.31,0,0,1-1.86,3.67Zm90.59-5.89a2.33,2.33,0,0,1-1.08-.27,2.3,2.3,0,0,1-.95-3.12l.11-.21a2.31,2.31,0,1,1,4.06,2.19l-.1.19A2.31,2.31,0,0,1,905.23,307.57Zm-96-3.49a2.31,2.31,0,0,1-2.1-1.35l-.11-.24a2.31,2.31,0,1,1,4.23-1.84l.08.17a2.3,2.3,0,0,1-1.14,3.05A2.34,2.34,0,0,1,809.21,304.08Zm100.18-6.52a2.24,2.24,0,0,1-.68-.1,2.3,2.3,0,0,1-1.52-2.88l0-.18a2.31,2.31,0,1,1,4.43,1.28l-.08.26A2.29,2.29,0,0,1,909.39,297.56ZM805.78,293.8a2.31,2.31,0,0,1-2.25-1.8l0-.22a2.31,2.31,0,1,1,4.51-1l0,.23a2.31,2.31,0,0,1-1.75,2.75A2.94,2.94,0,0,1,805.78,293.8Zm105.66-6.87-.23,0a2.3,2.3,0,0,1-2.07-2.52l0-.4a2.3,2.3,0,1,1,4.59.41l0,.45A2.31,2.31,0,0,1,911.44,286.93ZM804.51,283a2.3,2.3,0,0,1-2.3-2.26v-.27a2.31,2.31,0,0,1,4.62,0v.18a2.3,2.3,0,0,1-2.26,2.35Zm106.79-7.15a2.31,2.31,0,0,1-2.29-2l0-.23a2.31,2.31,0,0,1,4.58-.55l0,.23a2.31,2.31,0,0,1-2,2.57Zm-105.88-3.64a3,3,0,0,1-.41,0,2.3,2.3,0,0,1-1.86-2.68l.05-.27a2.31,2.31,0,1,1,4.52.91l0,.18A2.3,2.3,0,0,1,805.42,272.25Zm103.5-7a2.23,2.23,0,0,1-2.14-1.52l-.07-.21a2.31,2.31,0,1,1,4.37-1.48l0,.11a2.37,2.37,0,0,1-1.44,3A2.51,2.51,0,0,1,908.92,265.26Zm-100.45-3.41a2.2,2.2,0,0,1-.86-.17,2.3,2.3,0,0,1-1.27-3l.1-.25a2.3,2.3,0,1,1,4.24,1.8l-.07.18A2.32,2.32,0,0,1,808.47,261.85Zm96.07-6.42a2.32,2.32,0,0,1-2-1.14l-.12-.22a2.31,2.31,0,0,1,4-2.3l.1.17a2.31,2.31,0,0,1-.82,3.16A2.25,2.25,0,0,1,904.54,255.43Zm-91-3.15a2.3,2.3,0,0,1-1.91-3.58l.15-.22a2.3,2.3,0,1,1,3.79,2.62l-.11.16A2.3,2.3,0,0,1,813.56,252.28Zm84.66-5.65a2.29,2.29,0,0,1-1.73-.79l-.13-.14a2.31,2.31,0,0,1,3.42-3.1l.17.2a2.3,2.3,0,0,1-.21,3.25A2.26,2.26,0,0,1,898.22,246.63ZM820.49,244a2.31,2.31,0,0,1-1.62-3.95l.16-.16a2.31,2.31,0,1,1,3.24,3.28l-.17.16A2.31,2.31,0,0,1,820.49,244Zm69.77-4.68a2.24,2.24,0,0,1-1.39-.47l-.17-.12a2.31,2.31,0,0,1,2.76-3.7l.2.15a2.31,2.31,0,0,1-1.4,4.14Zm-61.33-2.11a2.31,2.31,0,0,1-1.26-4.24l.23-.14a2.3,2.3,0,1,1,2.45,3.9l-.15.1A2.27,2.27,0,0,1,828.93,237.16ZM881,233.67a2.43,2.43,0,0,1-1-.23l-.18-.09a2.31,2.31,0,1,1,2-4.18l.23.11a2.31,2.31,0,0,1-1,4.39Zm-42.43-1.46a2.31,2.31,0,0,1-.84-4.46l.25-.1a2.31,2.31,0,1,1,1.61,4.33l-.17.07A2.51,2.51,0,0,1,838.56,232.21Zm32.21-2.15a2.33,2.33,0,0,1-.53-.07l.46-2.26-.68,2.21a2.31,2.31,0,0,1,1.06-4.49l.16,0a2.34,2.34,0,0,1,1.74,2.79A2.3,2.3,0,0,1,870.77,230.06ZM849,229.3a2.31,2.31,0,0,1-.38-4.58l.24,0a2.3,2.3,0,0,1,.74,4.55l-.21,0Zm11-.73h-.3a2.31,2.31,0,0,1,.14-4.61h.25a2.31,2.31,0,0,1-.09,4.61Z" transform="translate(-122.78 -109.01)"></path>
                  </g>
                  <g class="cls-4">
                    <path d="M932.67,455.64a2.31,2.31,0,0,1-.09-4.61h.23a2.31,2.31,0,0,1,.18,4.61h-.32ZM922.08,455a2.19,2.19,0,0,1-.36,0l-.24,0a2.31,2.31,0,1,1,.75-4.55l.22,0a2.31,2.31,0,0,1-.37,4.59Zm21.31-.87a2.31,2.31,0,0,1-.59-4.54l.27-.06a2.31,2.31,0,1,1,1.09,4.48l-.18,0A2,2,0,0,1,943.39,454.12Zm-31.78-1.94a2.37,2.37,0,0,1-.82-.15l-.2-.08a2.31,2.31,0,1,1,1.62-4.32l.23.09a2.31,2.31,0,0,1-.83,4.46Zm42-1.7a2.34,2.34,0,0,1-2.08-1.29,2.31,2.31,0,0,1,1.06-3.09l.23-.11a2.31,2.31,0,0,1,2,4.16l-.19.09A2.3,2.3,0,0,1,953.6,450.48Zm-51.68-3.13a2.31,2.31,0,0,1-1.23-.36l-.19-.12A2.31,2.31,0,1,1,903,443l.2.13a2.31,2.31,0,0,1-1.23,4.26Zm61-2.49a2.3,2.3,0,0,1-1.36-4.16l.13-.1a2.3,2.3,0,0,1,2.82,3.64l-.23.18A2.3,2.3,0,0,1,962.87,444.86Zm-69.47-4.21a2.3,2.3,0,0,1-1.61-.66l-.16-.16a2.3,2.3,0,1,1,3.21-3.3l.17.16a2.31,2.31,0,0,1-1.61,4Zm77.42-3.14a2.28,2.28,0,0,1-1.51-.57,2.31,2.31,0,0,1-.23-3.26l.15-.17a2.31,2.31,0,0,1,3.48,3l-.15.17A2.3,2.3,0,0,1,970.82,437.51Zm-84.46-5.17a2.23,2.23,0,0,1-1.85-1s0-.08-.06-.08A2.38,2.38,0,0,1,885,428a2.26,2.26,0,0,1,3.16.51l.11.15a2.32,2.32,0,0,1-1.91,3.65Zm90.76-3.65a2.25,2.25,0,0,1-1.14-.31,2.3,2.3,0,0,1-.86-3.14l.11-.2a2.31,2.31,0,0,1,4,2.28l-.11.2A2.32,2.32,0,0,1,977.12,428.69Zm-96-5.87a2.23,2.23,0,0,1-2.07-1.37l0-.1a2.36,2.36,0,0,1,1.2-3.07,2.24,2.24,0,0,1,3,1.14l.06.15a2.35,2.35,0,0,1-1.21,3.06A2.38,2.38,0,0,1,881.17,422.82Zm100.34-4a2.4,2.4,0,0,1-.69-.1,2.31,2.31,0,0,1-1.51-2.89l.14-.43a2.3,2.3,0,0,1,4.37,1.46l-.11.34A2.3,2.3,0,0,1,981.51,418.78ZM878,412.49a2.3,2.3,0,0,1-2.25-1.84l0-.23a2.31,2.31,0,1,1,4.52-.91l0,.22a2.32,2.32,0,0,1-1.8,2.72A2.49,2.49,0,0,1,878,412.49ZM983.86,408h-.23a2.26,2.26,0,0,1-2.06-2.46l0-.24a2.31,2.31,0,0,1,4.59.46v.13A2.37,2.37,0,0,1,983.86,408ZM877,401.71a2.31,2.31,0,0,1-2.31-2.31v-.27a2.34,2.34,0,0,1,2.35-2.26,2.31,2.31,0,0,1,2.26,2.35v.18A2.31,2.31,0,0,1,877,401.71Zm107-4.52a2.32,2.32,0,0,1-2.3-2.08l0-.22a2.31,2.31,0,0,1,2.07-2.53,2.29,2.29,0,0,1,2.52,2.07l0,.22a2.3,2.3,0,0,1-2.06,2.53ZM878.2,390.94a2.2,2.2,0,0,1-.5-.06,2.3,2.3,0,0,1-1.75-2.75l0-.17a2.3,2.3,0,0,1,4.52.9l-.06.28A2.31,2.31,0,0,1,878.2,390.94Zm103.69-4.38a2.32,2.32,0,0,1-2.21-1.63l-.06-.2a2.31,2.31,0,1,1,4.4-1.38l.07.23a2.3,2.3,0,0,1-1.53,2.88A2.22,2.22,0,0,1,981.89,386.56Zm-100.37-5.94a2.22,2.22,0,0,1-.91-.19,2.31,2.31,0,0,1-1.21-3l.11-.25a2.31,2.31,0,0,1,4.2,1.91l-.07.17A2.32,2.32,0,0,1,881.52,380.62Zm96.19-4.05a2.32,2.32,0,0,1-2-1.17l-.13-.25a2.31,2.31,0,0,1,4.06-2.19l.08.16a2.3,2.3,0,0,1-.86,3.14A2.25,2.25,0,0,1,977.71,376.57Zm-90.88-5.39a2.34,2.34,0,0,1-1.32-.42,2.31,2.31,0,0,1-.57-3.21l.16-.22a2.31,2.31,0,1,1,3.74,2.7l-.11.16A2.33,2.33,0,0,1,886.83,371.18Zm84.79-3.58a2.3,2.3,0,0,1-1.79-.84l-.11-.14a2.3,2.3,0,0,1,3.5-3l.18.21a2.3,2.3,0,0,1-1.78,3.77ZM894,363a2.26,2.26,0,0,1-1.68-.73,2.31,2.31,0,0,1,.11-3.26l.15-.15a2.31,2.31,0,0,1,3.17,3.36l-.18.16A2.25,2.25,0,0,1,894,363Zm69.89-2.95a2.27,2.27,0,0,1-1.41-.48l-.19-.15a2.31,2.31,0,0,1,2.85-3.63l.17.13a2.31,2.31,0,0,1-1.42,4.13Zm-61.27-3.62a2.31,2.31,0,0,1-1.21-4.27l.21-.13a2.31,2.31,0,0,1,2.39,4l-.18.11A2.34,2.34,0,0,1,902.57,356.43Zm52.13-2.2a2.35,2.35,0,0,1-1-.24l-.2-.11a2.3,2.3,0,1,1,2.06-4.12l.2.1a2.31,2.31,0,0,1-1,4.37Zm-42.37-2.5a2.31,2.31,0,0,1-.8-4.47l.24-.09a2.31,2.31,0,1,1,1.54,4.35l-.17.06A2.32,2.32,0,0,1,912.33,351.73Zm32.25-1.36a2.28,2.28,0,0,1-.63-.09l-.18,0a2.31,2.31,0,1,1,1.18-4.46l.25.07a2.31,2.31,0,0,1-.62,4.53Zm-21.75-1.3a2.31,2.31,0,0,1-.34-4.59l.25,0a2.31,2.31,0,0,1,.64,4.57l-.2,0Zm11.06-.47h-.37a2.31,2.31,0,0,1,.28-4.61H934a2.31,2.31,0,0,1-.13,4.61Z" transform="translate(-122.78 -109.01)"></path>
                  </g>
                  <path d="M858.62,572.88a2.36,2.36,0,0,1-2.36-2.28,2.25,2.25,0,0,1,2.2-2.33h.23a2.27,2.27,0,0,1,2.35,2.26,2.31,2.31,0,0,1-2.26,2.36h-.16Zm-10.68-1a1.73,1.73,0,0,1-.45,0l-.19,0a2.31,2.31,0,0,1,.83-4.54l.26.05a2.31,2.31,0,0,1-.45,4.57Zm21.33-.21a2.31,2.31,0,0,1-.45-4.57l.17,0a2.31,2.31,0,0,1,1,4.51l-.27,0A2.4,2.4,0,0,1,869.27,571.7Zm-31.71-2.89a2.34,2.34,0,0,1-.86-.16l-.27-.11a2.31,2.31,0,0,1,1.84-4.24l.16.07a2.3,2.3,0,0,1-.87,4.44Zm42.1-.49a2.32,2.32,0,0,1-2.13-1.34,2.26,2.26,0,0,1,1.09-3l.21-.09a2.3,2.3,0,1,1,1.92,4.19l-.13.06A2.33,2.33,0,0,1,879.66,568.32ZM828,563.68a2.32,2.32,0,0,1-1.28-.39l-.11-.07A2.36,2.36,0,0,1,826,560a2.26,2.26,0,0,1,3.15-.67l.19.13a2.31,2.31,0,0,1-1.28,4.23Zm61-.65a2.31,2.31,0,0,1-1.36-4.17l.21-.16a2.31,2.31,0,1,1,2.66,3.77l-.15.11A2.31,2.31,0,0,1,889,563Zm-69.3-6.31a2.31,2.31,0,0,1-1.65-.7l-.16-.16a2.31,2.31,0,0,1,3.31-3.22l.15.16a2.3,2.3,0,0,1-1.65,3.92Zm77.48-.87a2.29,2.29,0,0,1-1.71-3.81l.15-.17A2.31,2.31,0,0,1,899,555l-.09.1A2.39,2.39,0,0,1,897.19,555.85Zm-84.26-7.63a2.24,2.24,0,0,1-1.9-1l0-.06a2.36,2.36,0,0,1,.61-3.25,2.25,2.25,0,0,1,3.16.59l.12.18a2.32,2.32,0,0,1-2,3.58Zm90.82-.93a2.3,2.3,0,0,1-2-3.51l.11-.19a2.31,2.31,0,1,1,4,2.39l-.12.21A2.32,2.32,0,0,1,903.75,547.29Zm-95.69-8.71a2.32,2.32,0,0,1-2.16-1.48l-.06-.17a2.3,2.3,0,1,1,4.27-1.73l.1.25a2.31,2.31,0,0,1-1.33,3A2.37,2.37,0,0,1,808.06,538.58Zm100.38-1.06a2.14,2.14,0,0,1-.78-.14,2.3,2.3,0,0,1-1.39-3l.08-.2a2.3,2.3,0,1,1,4.34,1.54l-.08.23A2.3,2.3,0,0,1,908.44,537.52Zm-103.25-9.39a2.31,2.31,0,0,1-2.27-1.94l0-.18a2.31,2.31,0,1,1,4.54-.82l.05.27a2.31,2.31,0,0,1-1.92,2.64A2.22,2.22,0,0,1,805.19,528.13ZM911.07,527l-.32,0a2.32,2.32,0,0,1-2-2.6l.06-.42a2.31,2.31,0,1,1,4.57.63l-.06.42A2.3,2.3,0,0,1,911.07,527Zm-106.56-9.69h-.09a2.3,2.3,0,0,1-2.21-2.4v-.23a2.3,2.3,0,1,1,4.6.19v.22A2.31,2.31,0,0,1,804.51,517.32Zm107-1.33a2.32,2.32,0,0,1-2.3-2.13v-.27a2.3,2.3,0,1,1,4.6-.27v.18a2.31,2.31,0,0,1-2.12,2.48ZM806,506.59a2.59,2.59,0,0,1-.55-.07,2.3,2.3,0,0,1-1.69-2.79l.05-.22a2.31,2.31,0,0,1,4.48,1.1l0,.22A2.31,2.31,0,0,1,806,506.59Zm103.77-1.29a2.33,2.33,0,0,1-2.22-1.66l-.07-.28a2.31,2.31,0,1,1,4.46-1.18l0,.17a2.3,2.3,0,0,1-1.57,2.86A2.35,2.35,0,0,1,909.78,505.3Zm-100.16-8.93a2.22,2.22,0,0,1-1-.23,2.3,2.3,0,0,1-1.08-3.07l.08-.17a2.3,2.3,0,1,1,4.19,1.91l-.11.25A2.3,2.3,0,0,1,809.62,496.37Zm96.28-1.19a2.3,2.3,0,0,1-2.06-1.25l-.1-.2a2.31,2.31,0,1,1,4.11-2.1l.1.2a2.31,2.31,0,0,1-1,3.1A2.35,2.35,0,0,1,905.9,495.18Zm-90.67-8.13a2.32,2.32,0,0,1-1.37-.45,2.29,2.29,0,0,1-.48-3.2l.06-.07a2.37,2.37,0,0,1,3.26-.51,2.25,2.25,0,0,1,.53,3.15l-.12.15A2.38,2.38,0,0,1,815.23,487.05ZM900,486a2.18,2.18,0,0,1-1.7-.81l-.12-.14a2.34,2.34,0,0,1,.35-3.27,2.27,2.27,0,0,1,3.21.33l.06.07a2.37,2.37,0,0,1-.32,3.29A2.32,2.32,0,0,1,900,486Zm-77.39-6.88a2.26,2.26,0,0,1-1.74-.79,2.3,2.3,0,0,1,.22-3.25l.15-.13a2.31,2.31,0,0,1,3.08,3.44l-.2.17A2.3,2.3,0,0,1,822.59,479.14Zm69.88-.88a2.17,2.17,0,0,1-1.41-.51l-.18-.14a2.31,2.31,0,1,1,2.93-3.57l.1.08a2.35,2.35,0,0,1,.34,3.28A2.31,2.31,0,0,1,892.47,478.26Zm-61.08-5.43a2.31,2.31,0,0,1-1.14-4.31l.18-.1a2.3,2.3,0,0,1,2.32,4l-.22.13A2.34,2.34,0,0,1,831.39,472.83Zm52.17-.66a2.31,2.31,0,0,1-1.1-.28l-.18-.1a2.31,2.31,0,0,1,2.17-4.07l.22.12a2.31,2.31,0,0,1-1.11,4.33Zm-42.28-3.76a2.31,2.31,0,0,1-.73-4.5l.25-.08a2.31,2.31,0,0,1,1.4,4.4l-.19.06A2.33,2.33,0,0,1,841.28,468.41Zm32.28-.4a2.29,2.29,0,0,1-.68-.1l-.19-.06a2.31,2.31,0,0,1,1.29-4.43l.25.08a2.31,2.31,0,0,1-.67,4.51Zm-21.7-1.94a2.3,2.3,0,0,1-.27-4.59l.27,0a2.31,2.31,0,0,1,.45,4.6l-.17,0Zm11.06-.12h-.18l-.23,0a2.3,2.3,0,0,1-2.11-2.48,2.33,2.33,0,0,1,2.48-2.12H863a2.36,2.36,0,0,1,2.15,2.5A2.27,2.27,0,0,1,862.92,466Z" transform="translate(-122.78 -109.01)"></path>
                  <path d="M755,682.32a2.31,2.31,0,0,1-.13-4.61H755a2.31,2.31,0,0,1,.37,4.6l-.28,0Zm-10.6-.33-.32,0-.18,0a2.31,2.31,0,0,1,.55-4.58l.27,0a2.31,2.31,0,0,1-.32,4.59Zm21.28-1.49a2.31,2.31,0,0,1-.6-4.54l.19-.05a2.31,2.31,0,0,1,1.27,4.44l-.25.07A2.55,2.55,0,0,1,765.67,680.5Zm-31.83-1a2.37,2.37,0,0,1-.73-.12l-.15,0a2.35,2.35,0,0,1-1.47-2.94,2.26,2.26,0,0,1,2.88-1.45l-.66,2.21.86-2.14a2.3,2.3,0,0,1-.73,4.49Zm41.93-3a2.31,2.31,0,0,1-1.11-4.33l.26-.14a2.31,2.31,0,1,1,2.09,4.11l-.14.08A2.31,2.31,0,0,1,775.77,676.55ZM724,675a2.34,2.34,0,0,1-1.17-.32l-.22-.13a2.31,2.31,0,0,1,2.39-3.95l.17.11A2.3,2.3,0,0,1,724,675Zm60.84-4.32a2.31,2.31,0,0,1-1.41-4.13l.13-.1a2.3,2.3,0,1,1,2.92,3.56l-.23.19A2.31,2.31,0,0,1,784.85,670.65Zm-69.55-2.13a2.28,2.28,0,0,1-1.56-.61l-.15-.13a2.31,2.31,0,0,1,3.08-3.44l.19.18a2.3,2.3,0,0,1-1.56,4Zm77.28-5.47a2.3,2.3,0,0,1-1.79-3.77l.15-.17A2.3,2.3,0,0,1,794.5,662l-.14.18A2.31,2.31,0,0,1,792.58,663.05Zm-84.52-2.59a2.34,2.34,0,0,1-1.87-.94l-.13-.19a2.31,2.31,0,1,1,3.73-2.71l.13.17a2.3,2.3,0,0,1-1.86,3.67Zm90.56-6.4a2.23,2.23,0,0,1-1-.26,2.3,2.3,0,0,1-1-3.1l.12-.24a2.31,2.31,0,0,1,4.07,2.17l-.09.17A2.29,2.29,0,0,1,798.62,654.06Zm-96-2.94a2.31,2.31,0,0,1-2.1-1.35l-.09-.19a2.31,2.31,0,1,1,4.19-2l.1.22a2.31,2.31,0,0,1-1.14,3.06A2.34,2.34,0,0,1,702.58,651.12ZM802.72,644a2.43,2.43,0,0,1-.65-.09,2.32,2.32,0,0,1-1.57-2.87l.06-.2a2.31,2.31,0,1,1,4.44,1.26l-.07.24A2.31,2.31,0,0,1,802.72,644Zm-103.63-3.17a2.31,2.31,0,0,1-2.25-1.8l0-.19a2.31,2.31,0,0,1,4.49-1.08l.06.26a2.31,2.31,0,0,1-1.75,2.75A2.22,2.22,0,0,1,699.09,640.86Zm105.62-7.48h-.18a2.3,2.3,0,0,1-2.12-2.48v-.23a2.4,2.4,0,0,1,2.48-2.22,2.22,2.22,0,0,1,2.14,2.35v.13l0,.33A2.3,2.3,0,0,1,804.71,633.38Zm-107-3.27a2.32,2.32,0,0,1-2.31-2.26v-.23a2.3,2.3,0,0,1,2.26-2.35,2.35,2.35,0,0,1,2.35,2.26v.22a2.32,2.32,0,0,1-2.26,2.36Zm106.74-7.77a2.3,2.3,0,0,1-2.28-2l0-.27a2.31,2.31,0,0,1,4.58-.55l0,.19a2.3,2.3,0,0,1-2,2.6Zm-105.89-3a2.71,2.71,0,0,1-.41,0,2.31,2.31,0,0,1-1.87-2.68l0-.23a2.3,2.3,0,1,1,4.53.83l0,.22A2.33,2.33,0,0,1,698.61,619.31Zm103.5-7.53a2.32,2.32,0,0,1-2.17-1.53l-.09-.26a2.31,2.31,0,0,1,4.38-1.47l0,.17a2.31,2.31,0,0,1-1.39,2.95A2.33,2.33,0,0,1,802.11,611.78ZM701.6,608.89a2.25,2.25,0,0,1-.87-.17,2.3,2.3,0,0,1-1.27-3l.09-.21a2.3,2.3,0,1,1,4.27,1.73l-.08.21A2.31,2.31,0,0,1,701.6,608.89Zm96-7a2.31,2.31,0,0,1-2-1.14l-.09-.16a2.31,2.31,0,0,1,4-2.39l.13.23a2.3,2.3,0,0,1-.83,3.15A2.35,2.35,0,0,1,797.63,601.91Zm-91-2.61a2.31,2.31,0,0,1-1.92-3.59l.11-.17a2.31,2.31,0,0,1,3.87,2.52l-.14.21A2.31,2.31,0,0,1,706.64,599.3Zm84.62-6.15a2.3,2.3,0,0,1-1.7-.74l-.18-.19a2.31,2.31,0,0,1,3.44-3.08l.14.15a2.31,2.31,0,0,1-.14,3.26A2.33,2.33,0,0,1,791.26,593.15Zm-77.75-2.23a2.31,2.31,0,0,1-1.63-3.94l.16-.16a2.31,2.31,0,0,1,3.26,3.26l-.16.16A2.3,2.3,0,0,1,713.51,590.92Zm69.74-5.08a2.31,2.31,0,0,1-1.38-.46l-.16-.12a2.31,2.31,0,1,1,2.73-3.72l.2.15a2.31,2.31,0,0,1-1.39,4.15Zm-61.33-1.76a2.3,2.3,0,0,1-1.28-4.22l.24-.16a2.31,2.31,0,0,1,2.45,3.91l-.13.09A2.33,2.33,0,0,1,721.92,584.08Zm52-3.79a2.33,2.33,0,0,1-1-.22l-.17-.08a2.31,2.31,0,0,1,1.91-4.2l.25.11a2.31,2.31,0,0,1-1,4.39Zm-42.43-1.22a2.3,2.3,0,0,1-.86-4.44l.23-.09a2.3,2.3,0,1,1,1.68,4.29l-.19.08A2.34,2.34,0,0,1,731.52,579.07Zm32.19-2.33a2.05,2.05,0,0,1-.49-.06l-.16,0a2.35,2.35,0,0,1-1.77-2.77,2.27,2.27,0,0,1,2.71-1.75l.11,0a2.36,2.36,0,0,1,1.79,2.77A2.27,2.27,0,0,1,763.71,576.74Zm-21.77-.63a2.31,2.31,0,0,1-.41-4.58l.26,0a2.31,2.31,0,0,1,.75,4.55l-.19,0A2,2,0,0,1,741.94,576.11Zm11-.79h-.27a2.31,2.31,0,0,1,0-4.61h.32a2.31,2.31,0,0,1-.09,4.61Z" transform="translate(-122.78 -109.01)"></path>
                  <path d="M424.68,572.86h-.23a2.36,2.36,0,0,1-2.25-2.41,2.25,2.25,0,0,1,2.34-2.2h.23a2.31,2.31,0,0,1-.09,4.61Zm10.59-.52a2.31,2.31,0,0,1-.32-4.59l.18,0a2.31,2.31,0,0,1,.73,4.56l-.27,0Zm-21.3-1.1a2.46,2.46,0,0,1-.6-.07l-.17,0a2.31,2.31,0,1,1,1.09-4.48l.27.07a2.3,2.3,0,0,1-.59,4.53Zm31.89-1.61a2.34,2.34,0,0,1-2.19-1.48,2.24,2.24,0,0,1,1.28-2.94l.22-.08a2.3,2.3,0,1,1,1.63,4.31l-.11,0A2.39,2.39,0,0,1,445.86,569.63Zm-42.06-2.14a2.22,2.22,0,0,1-1-.23l-.25-.12a2.31,2.31,0,1,1,2.09-4.11l.16.08a2.3,2.3,0,0,1-1,4.38Zm51.71-2.57a2.3,2.3,0,0,1-1.2-4.27l.16-.1a2.3,2.3,0,1,1,2.47,3.89l-.22.15A2.42,2.42,0,0,1,455.51,564.92Zm-60.91-3.15a2.28,2.28,0,0,1-1.41-.49l-.18-.14a2.31,2.31,0,1,1,2.83-3.64l.18.14a2.31,2.31,0,0,1-1.42,4.13Zm69.5-3.45a2.31,2.31,0,0,1-1.56-4l.13-.12a2.31,2.31,0,0,1,3.19,3.33l-.2.19A2.28,2.28,0,0,1,464.1,558.32Zm-77.36-4a2.31,2.31,0,0,1-1.74-.79l-.17-.2a2.31,2.31,0,0,1,3.52-3l.13.15a2.31,2.31,0,0,1-.23,3.26A2.26,2.26,0,0,1,386.74,554.31Zm84.45-4.21a2.26,2.26,0,0,1-1.31-.41,2.3,2.3,0,0,1-.58-3.2l.12-.17a2.31,2.31,0,0,1,3.8,2.63l-.11.16A2.36,2.36,0,0,1,471.19,550.1Zm-90.66-4.67a2.3,2.3,0,0,1-2-1.18l-.12-.22a2.31,2.31,0,1,1,4.05-2.21l.1.18a2.31,2.31,0,0,1-.89,3.14A2.28,2.28,0,0,1,380.53,545.43Zm96-4.75a2.2,2.2,0,0,1-.93-.2,2.3,2.3,0,0,1-1.17-3.05l.07-.17a2.31,2.31,0,0,1,4.25,1.8l-.11.25A2.3,2.3,0,0,1,476.49,540.68Zm-100.26-5.19a2.32,2.32,0,0,1-2.2-1.62l-.07-.23a2.31,2.31,0,1,1,4.41-1.35l.07.2a2.31,2.31,0,0,1-1.52,2.89A2.37,2.37,0,0,1,376.23,535.49Zm103.55-5.14a2.21,2.21,0,0,1-.51-.05,2.31,2.31,0,0,1-1.74-2.76l0-.17a2.31,2.31,0,0,1,4.53.9l-.06.28A2.3,2.3,0,0,1,479.78,530.35ZM374,524.88a2.31,2.31,0,0,1-2.29-2.08l0-.23a2.31,2.31,0,0,1,4.6-.45l0,.22a2.31,2.31,0,0,1-2.07,2.53Zm106.87-5.3h0a2.31,2.31,0,0,1-2.28-2.33v-.43a2.31,2.31,0,0,1,4.61,0v.48A2.3,2.3,0,0,1,480.91,519.58ZM374,514.05l-.23,0a2.29,2.29,0,0,1-2.06-2.52l0-.25a2.31,2.31,0,0,1,4.59.5l0,.21A2.32,2.32,0,0,1,374,514.05Zm105.8-5.47a2.31,2.31,0,0,1-2.26-1.86l0-.19a2.31,2.31,0,1,1,4.51-1l.06.26a2.3,2.3,0,0,1-1.81,2.71A2.49,2.49,0,0,1,479.82,508.58Zm-103.65-5.15a2.31,2.31,0,0,1-2.21-3l.08-.23a2.31,2.31,0,1,1,4.4,1.39l-.07.2A2.3,2.3,0,0,1,376.17,503.43Zm100.42-5.19a2.31,2.31,0,0,1-2.13-1.41l-.08-.19a2.3,2.3,0,1,1,4.23-1.83l.1.22a2.3,2.3,0,0,1-1.22,3A2.24,2.24,0,0,1,476.59,498.24Zm-96.17-4.78a2.26,2.26,0,0,1-1.12-.29,2.31,2.31,0,0,1-.89-3.14l.11-.2a2.31,2.31,0,0,1,4,2.24l-.11.2A2.32,2.32,0,0,1,380.42,493.46Zm90.91-4.69a2.31,2.31,0,0,1-1.91-1l-.11-.15a2.31,2.31,0,0,1,3.77-2.67l.16.23a2.3,2.3,0,0,1-.62,3.2A2.28,2.28,0,0,1,471.33,488.77Zm-84.73-4.21a2.31,2.31,0,0,1-1.74-3.82l.11-.14a2.31,2.31,0,1,1,3.55,2.95l-.18.21A2.3,2.3,0,0,1,386.6,484.56Zm77.67-4a2.32,2.32,0,0,1-1.56-.61l-.2-.19a2.31,2.31,0,0,1,3.19-3.33l.13.12a2.31,2.31,0,0,1,.14,3.26A2.34,2.34,0,0,1,464.27,480.55Zm-69.84-3.48a2.31,2.31,0,0,1-1.41-4.13l.17-.13a2.3,2.3,0,0,1,2.84,3.63l-.19.15A2.31,2.31,0,0,1,394.43,477.07Zm61.28-3.17a2.23,2.23,0,0,1-1.19-.33l-.23-.14a2.31,2.31,0,1,1,2.46-3.91l.16.1a2.31,2.31,0,0,1,.78,3.17A2.33,2.33,0,0,1,455.71,473.9Zm-52.1-2.59a2.31,2.31,0,0,1-1-4.38l.18-.09a2.31,2.31,0,0,1,2.08,4.12l-.23.11A2.3,2.3,0,0,1,403.61,471.31Zm42.36-2.2a2.19,2.19,0,0,1-.75-.13l-.22-.08a2.3,2.3,0,0,1,1.55-4.34l.12,0a2.36,2.36,0,0,1,1.43,3A2.28,2.28,0,0,1,446,469.11Zm-32.22-1.59a2.31,2.31,0,0,1-.59-4.54l.26-.07a2.31,2.31,0,0,1,1.11,4.48l-.19.05A2.33,2.33,0,0,1,413.75,467.52Zm21.75-1.12-.32,0-.22,0a2.31,2.31,0,1,1,.64-4.57l.13,0a2.36,2.36,0,0,1,2,2.62A2.28,2.28,0,0,1,435.5,466.4Zm-11.05-.55a2.3,2.3,0,0,1-.13-4.6l.27,0a2.28,2.28,0,0,1,2.4,2.21,2.3,2.3,0,0,1-2.21,2.4h-.33Z" transform="translate(-122.78 -109.01)"></path>
                  <g class="cls-4">
                    <path d="M521.72,682.33h-.23a2.34,2.34,0,0,1-2.24-2.41,2.24,2.24,0,0,1,2.33-2.21h.23a2.31,2.31,0,0,1-.09,4.62Zm10.59-.52a2.31,2.31,0,0,1-.31-4.59l.18,0a2.3,2.3,0,1,1,.72,4.55l-.27,0Zm-21.3-1.1a2.39,2.39,0,0,1-.59-.08l-.18,0a2.31,2.31,0,0,1,1.1-4.49l.26.07a2.31,2.31,0,0,1-.59,4.54Zm31.9-1.61a2.34,2.34,0,0,1-2.2-1.48,2.26,2.26,0,0,1,1.28-3l.22-.08a2.31,2.31,0,0,1,1.64,4.32l-.12,0A2.37,2.37,0,0,1,542.91,679.1ZM500.84,677a2.39,2.39,0,0,1-1-.23l-.24-.12a2.31,2.31,0,1,1,2.08-4.12l.17.09a2.31,2.31,0,0,1-1,4.38Zm51.72-2.57a2.31,2.31,0,0,1-1.21-4.27l.16-.1a2.3,2.3,0,1,1,2.47,3.89l-.22.14A2.3,2.3,0,0,1,552.56,674.39Zm-60.92-3.16a2.27,2.27,0,0,1-1.41-.48l-.18-.14a2.31,2.31,0,0,1,2.83-3.65l.18.14a2.31,2.31,0,0,1-1.42,4.13Zm69.5-3.44a2.31,2.31,0,0,1-1.56-4l.13-.12A2.31,2.31,0,0,1,562.9,667l-.2.19A2.32,2.32,0,0,1,561.14,667.79Zm-77.36-4A2.3,2.3,0,0,1,482,663l-.17-.19a2.31,2.31,0,0,1,3.53-3l.12.15a2.31,2.31,0,0,1-1.74,3.82Zm84.45-4.21a2.3,2.3,0,0,1-1.88-3.61l.12-.17a2.3,2.3,0,1,1,3.79,2.62l-.11.16A2.33,2.33,0,0,1,568.23,659.57Zm-90.66-4.67a2.29,2.29,0,0,1-2-1.19l-.12-.21a2.31,2.31,0,0,1,4.05-2.21l.1.18a2.31,2.31,0,0,1-.9,3.14A2.26,2.26,0,0,1,477.57,654.9Zm96-4.75a2.37,2.37,0,0,1-.94-.2,2.32,2.32,0,0,1-1.17-3.05l.08-.17a2.3,2.3,0,0,1,4.24,1.8l-.11.25A2.3,2.3,0,0,1,573.54,650.15ZM473.28,645a2.29,2.29,0,0,1-2.2-1.62l-.08-.23a2.31,2.31,0,0,1,4.42-1.35l.06.21a2.31,2.31,0,0,1-1.52,2.89A2.24,2.24,0,0,1,473.28,645Zm103.54-5.13a2.14,2.14,0,0,1-.5-.06,2.3,2.3,0,0,1-1.75-2.75l0-.17a2.31,2.31,0,0,1,4.53.9l-.06.28A2.31,2.31,0,0,1,576.82,639.82Zm-105.74-5.48a2.3,2.3,0,0,1-2.29-2.07l0-.23a2.31,2.31,0,1,1,4.59-.45l0,.22a2.3,2.3,0,0,1-2.06,2.52ZM578,629.05h0a2.32,2.32,0,0,1-2.29-2.33v-.43a2.31,2.31,0,0,1,4.62,0v.47A2.32,2.32,0,0,1,578,629.05Zm-106.88-5.54h-.23a2.31,2.31,0,0,1-2.07-2.53l0-.24a2.31,2.31,0,0,1,4.59.5l0,.2A2.31,2.31,0,0,1,471.07,623.51ZM576.85,618a2.27,2.27,0,0,1-2.24-1.82,2.39,2.39,0,0,1,1.75-2.84,2.22,2.22,0,0,1,2.72,1.67l0,.2a2.33,2.33,0,0,1-1.8,2.74A2.5,2.5,0,0,1,576.85,618Zm-103.64-5.13a2.22,2.22,0,0,1-.67-.1,2.3,2.3,0,0,1-1.53-2.88l.07-.24a2.31,2.31,0,0,1,4.4,1.39l-.06.2A2.31,2.31,0,0,1,473.21,612.89Zm100.42-5.18a2.3,2.3,0,0,1-2.12-1.41l-.08-.19a2.31,2.31,0,1,1,4.23-1.84l.09.23a2.3,2.3,0,0,1-1.22,3A2.21,2.21,0,0,1,573.63,607.71Zm-96.17-4.78a2.32,2.32,0,0,1-2-3.43l.11-.2a2.31,2.31,0,1,1,4,2.24l-.11.2A2.31,2.31,0,0,1,477.46,602.93Zm90.91-4.69a2.31,2.31,0,0,1-1.91-1l-.1-.14a2.31,2.31,0,1,1,3.76-2.67l.16.22a2.31,2.31,0,0,1-.62,3.21A2.26,2.26,0,0,1,568.37,598.24ZM483.64,594a2.28,2.28,0,0,1-1.51-.56,2.31,2.31,0,0,1-.23-3.26l.12-.13a2.3,2.3,0,1,1,3.54,2.95l-.18.21A2.29,2.29,0,0,1,483.64,594Zm77.67-4a2.35,2.35,0,0,1-1.56-.6l-.2-.19a2.31,2.31,0,1,1,3.2-3.33l.13.12a2.31,2.31,0,0,1-1.57,4Zm-69.83-3.47a2.31,2.31,0,0,1-1.42-4.13l.17-.13a2.3,2.3,0,1,1,2.85,3.62l-.19.15A2.28,2.28,0,0,1,491.48,586.54Zm61.27-3.17a2.29,2.29,0,0,1-1.19-.34l-.23-.14a2.31,2.31,0,0,1,2.46-3.9l.16.1a2.31,2.31,0,0,1-1.2,4.28Zm-52.1-2.6a2.31,2.31,0,0,1-1-4.38l.18-.08a2.3,2.3,0,1,1,2.08,4.11l-.23.12A2.26,2.26,0,0,1,500.65,580.77ZM543,578.58a2.28,2.28,0,0,1-.75-.13l-.22-.08A2.31,2.31,0,0,1,543.6,574l.11,0a2.37,2.37,0,0,1,1.44,3A2.29,2.29,0,0,1,543,578.58ZM510.79,577a2.31,2.31,0,0,1-.59-4.54l.26-.06a2.31,2.31,0,0,1,1.11,4.48l-.18,0A2.06,2.06,0,0,1,510.79,577Zm21.76-1.12a1.67,1.67,0,0,1-.32,0l-.23,0a2.31,2.31,0,0,1,.64-4.57l.14,0a2.35,2.35,0,0,1,2,2.62A2.25,2.25,0,0,1,532.55,575.86Zm-11-.54a2.31,2.31,0,0,1-.14-4.61h.28a2.28,2.28,0,0,1,2.39,2.21,2.31,2.31,0,0,1-2.21,2.4h-.32Z" transform="translate(-122.78 -109.01)"></path>
                  </g>
                  <path d="M609.89,295.27a2.23,2.23,0,0,1-1.85-1l-.06-.11a2.3,2.3,0,1,1,3.83-2.56,2.36,2.36,0,0,1-.6,3.25A2.41,2.41,0,0,1,609.89,295.27Zm-6-9.07a2.21,2.21,0,0,1-1.85-1l-.07-.1a2.31,2.31,0,0,1,3.84-2.57,2.37,2.37,0,0,1-.6,3.26A2.4,2.4,0,0,1,603.86,286.2Zm-6-9.06a2.2,2.2,0,0,1-1.86-1l-.07-.1a2.31,2.31,0,0,1,3.85-2.55,2.33,2.33,0,0,1-1.92,3.65Zm-6-9.06a2.21,2.21,0,0,1-1.85-1l-.07-.11a2.31,2.31,0,0,1,3.84-2.56,2.36,2.36,0,0,1-.6,3.25A2.41,2.41,0,0,1,591.79,268.08Zm-6-9.07a2.2,2.2,0,0,1-1.85-1l-.07-.1a2.31,2.31,0,0,1,3.83-2.57,2.37,2.37,0,0,1-.6,3.26A2.34,2.34,0,0,1,585.76,259Zm-6-9.06a2.2,2.2,0,0,1-1.85-1l-.07-.1a2.31,2.31,0,0,1,3.85-2.55,2.33,2.33,0,0,1-1.93,3.65Zm-6-9.06a2.24,2.24,0,0,1-1.86-1l-.06-.11a2.3,2.3,0,0,1,3.84-2.54,2.33,2.33,0,0,1-1.92,3.65Zm-6-9.07a2.2,2.2,0,0,1-1.85-1l-.07-.1a2.31,2.31,0,1,1,3.83-2.57,2.33,2.33,0,0,1-1.91,3.66Zm-6-9.06a2.23,2.23,0,0,1-1.86-1l-.07-.1a2.31,2.31,0,0,1,3.86-2.53,2.35,2.35,0,0,1-.63,3.24A2.31,2.31,0,0,1,561.62,222.76Z" transform="translate(-122.78 -109.01)"></path>
                  <path d="M565.1,347.24a2.29,2.29,0,0,1-.94-.21l-.11,0a2.31,2.31,0,1,1,2-4.19,2.37,2.37,0,0,1,1.17,3.1A2.31,2.31,0,0,1,565.1,347.24Zm-9.86-4.61a2.29,2.29,0,0,1-.94-.21l-.11-.05a2.31,2.31,0,1,1,1.94-4.19,2.37,2.37,0,0,1,1.18,3.09A2.3,2.3,0,0,1,555.24,342.63ZM545.38,338a2.25,2.25,0,0,1-.94-.21l-.11-.05a2.31,2.31,0,1,1,1.93-4.19,2.35,2.35,0,0,1,1.18,3.09A2.28,2.28,0,0,1,545.38,338Zm-9.87-4.61a2.15,2.15,0,0,1-.94-.22l-.11-.05a2.31,2.31,0,1,1,1.95-4.18,2.36,2.36,0,0,1,1.17,3.09A2.3,2.3,0,0,1,535.51,333.41Zm-9.86-4.62a2.11,2.11,0,0,1-.94-.21l-.12-.05a2.31,2.31,0,0,1,1.95-4.18,2.35,2.35,0,0,1,1.17,3.09A2.27,2.27,0,0,1,525.65,328.79Zm-9.86-4.61a2.11,2.11,0,0,1-.94-.21l-.11-.05a2.31,2.31,0,0,1,1.93-4.19,2.36,2.36,0,0,1,1.18,3.09A2.28,2.28,0,0,1,515.79,324.18Zm-9.87-4.61a2.33,2.33,0,0,1-.95-.21l-.11-.06a2.3,2.3,0,1,1,2-4.17,2.35,2.35,0,0,1,1.17,3.09A2.29,2.29,0,0,1,505.92,319.57ZM496.06,315a2.21,2.21,0,0,1-1-.22l-.11-.05a2.31,2.31,0,1,1,2-4.17,2.36,2.36,0,0,1,1.16,3.1A2.3,2.3,0,0,1,496.06,315Zm-9.87-4.61a2.2,2.2,0,0,1-.95-.22l-.11-.05a2.31,2.31,0,1,1,2-4.17,2.37,2.37,0,0,1,1.16,3.1A2.3,2.3,0,0,1,486.19,310.35Z" transform="translate(-122.78 -109.01)"></path>
                  <path d="M486.14,493.31a2.31,2.31,0,0,1-1-4.38,2.36,2.36,0,0,1,3.14,1,2.26,2.26,0,0,1-1,3.06l-.11.06A2.3,2.3,0,0,1,486.14,493.31ZM496,488.6a2.31,2.31,0,0,1-1-4.38,2.36,2.36,0,0,1,3.14,1,2.25,2.25,0,0,1-1,3.05l-.11.06A2.44,2.44,0,0,1,496,488.6Zm9.81-4.71a2.31,2.31,0,0,1-1-4.4,2.35,2.35,0,0,1,3.12,1.08,2.24,2.24,0,0,1-1,3l-.11.06A2.33,2.33,0,0,1,505.77,483.89Zm9.82-4.72a2.31,2.31,0,0,1-1-4.39,2.37,2.37,0,0,1,3.13,1.07,2.26,2.26,0,0,1-1,3l-.11.05A2.33,2.33,0,0,1,515.59,479.17Zm9.82-4.71a2.31,2.31,0,0,1-1-4.39,2.36,2.36,0,0,1,3.12,1.07,2.26,2.26,0,0,1-1,3.05l-.11.05A2.29,2.29,0,0,1,525.41,474.46Zm9.81-4.71a2.31,2.31,0,0,1-1-4.39,2.36,2.36,0,0,1,3.13,1.07,2.27,2.27,0,0,1-1,3.05l-.11,0A2.33,2.33,0,0,1,535.22,469.75ZM545,465a2.31,2.31,0,0,1-1-4.39,2.35,2.35,0,0,1,3.13,1.06,2.25,2.25,0,0,1-1,3.05l-.11.05A2.35,2.35,0,0,1,545,465Zm9.81-4.72a2.31,2.31,0,0,1-1-4.39A2.37,2.37,0,0,1,557,457a2.26,2.26,0,0,1-1,3.05l-.11.05A2.33,2.33,0,0,1,554.85,460.32Zm9.82-4.71a2.31,2.31,0,0,1-1-4.39,2.37,2.37,0,0,1,3.13,1.07,2.27,2.27,0,0,1-1,3l-.11.05A2.29,2.29,0,0,1,564.67,455.61Z" transform="translate(-122.78 -109.01)"></path>
                  <g class="cls-4">
                    <path d="M561.06,582.2a2.31,2.31,0,0,1-1.94-3.55,2.34,2.34,0,0,1,3.22-.74,2.25,2.25,0,0,1,.73,3.13l-.07.1A2.29,2.29,0,0,1,561.06,582.2Zm5.9-9.15A2.29,2.29,0,0,1,565,569.5a2.36,2.36,0,0,1,3.22-.74,2.25,2.25,0,0,1,.72,3.13l-.07.11A2.3,2.3,0,0,1,567,573.05Zm5.91-9.14a2.31,2.31,0,0,1-1.94-3.56,2.36,2.36,0,0,1,3.22-.74,2.26,2.26,0,0,1,.73,3.14l-.07.1A2.31,2.31,0,0,1,572.87,563.91Zm5.9-9.15a2.37,2.37,0,0,1-1.24-.36,2.31,2.31,0,0,1-.7-3.19,2.37,2.37,0,0,1,3.22-.76,2.27,2.27,0,0,1,.74,3.14l-.07.1A2.31,2.31,0,0,1,578.77,554.76Zm5.91-9.15a2.28,2.28,0,0,1-1.25-.37,2.31,2.31,0,0,1-.69-3.19,2.36,2.36,0,0,1,3.22-.74,2.26,2.26,0,0,1,.72,3.14l-.06.1A2.31,2.31,0,0,1,584.68,545.61Zm5.9-9.15a2.31,2.31,0,0,1-1.94-3.56,2.36,2.36,0,0,1,3.23-.73,2.25,2.25,0,0,1,.72,3.13l-.07.1A2.29,2.29,0,0,1,590.58,536.46Zm5.9-9.15a2.26,2.26,0,0,1-1.24-.36,2.31,2.31,0,0,1-.69-3.19,2.34,2.34,0,0,1,3.22-.74,2.25,2.25,0,0,1,.72,3.13l-.06.11A2.33,2.33,0,0,1,596.48,527.31Zm5.91-9.15a2.3,2.3,0,0,1-1.94-3.55,2.36,2.36,0,0,1,3.22-.74,2.24,2.24,0,0,1,.73,3.13l-.07.11A2.3,2.3,0,0,1,602.39,518.16Zm5.9-9.14a2.3,2.3,0,0,1-1.93-3.56,2.36,2.36,0,0,1,3.22-.74,2.26,2.26,0,0,1,.72,3.14l-.07.1A2.31,2.31,0,0,1,608.29,509Z" transform="translate(-122.78 -109.01)"></path>
                  </g>
                  <path d="M721,583.26a2.32,2.32,0,0,1-2-1.1,2.37,2.37,0,0,1,.73-3.23,2.26,2.26,0,0,1,3.14.71l.07.1a2.31,2.31,0,0,1-2,3.52Zm-5.82-9.2a2.28,2.28,0,0,1-2-1.08,2.35,2.35,0,0,1,.69-3.23,2.24,2.24,0,0,1,3.14.67l.07.1a2.3,2.3,0,0,1-.73,3.18A2.28,2.28,0,0,1,715.2,574.06Zm-5.82-9.2a2.31,2.31,0,0,1-2-1.08,2.36,2.36,0,0,1,.69-3.23,2.25,2.25,0,0,1,3.15.67l.07.1a2.3,2.3,0,0,1-.73,3.18A2.28,2.28,0,0,1,709.38,564.86Zm-5.83-9.2a2.3,2.3,0,0,1-1.95-1.08,2.35,2.35,0,0,1,.69-3.23,2.25,2.25,0,0,1,3.15.67l.06.1a2.31,2.31,0,0,1-2,3.54Zm-5.82-9.2a2.31,2.31,0,0,1-2-1.07,2.37,2.37,0,0,1,.68-3.24,2.26,2.26,0,0,1,3.15.65l.06.11a2.3,2.3,0,0,1-.7,3.18A2.27,2.27,0,0,1,697.73,546.46Zm-5.82-9.2a2.3,2.3,0,0,1-2-1.09,2.35,2.35,0,0,1,.7-3.23,2.26,2.26,0,0,1,3.15.69l.06.1a2.3,2.3,0,0,1-.73,3.18A2.38,2.38,0,0,1,691.91,537.26Zm-5.83-9.21a2.29,2.29,0,0,1-1.94-1.06,2.36,2.36,0,0,1,.67-3.24,2.26,2.26,0,0,1,3.15.65l.07.11a2.3,2.3,0,0,1-.71,3.18A2.23,2.23,0,0,1,686.08,528.05Zm-5.82-9.2a2.32,2.32,0,0,1-2-1.06,2.36,2.36,0,0,1,.68-3.24,2.26,2.26,0,0,1,3.15.65l.07.11a2.31,2.31,0,0,1-.71,3.18A2.23,2.23,0,0,1,680.26,518.85Zm-5.82-9.19a2.31,2.31,0,0,1-2-1.07,2.37,2.37,0,0,1,.67-3.24,2.27,2.27,0,0,1,3.16.65l.06.11a2.31,2.31,0,0,1-1.94,3.55Z" transform="translate(-122.78 -109.01)"></path>
                  <path d="M800.36,492a2.36,2.36,0,0,1-2.15-3.3,2.25,2.25,0,0,1,3-1.16l.12.06a2.31,2.31,0,0,1-1,4.4Zm-9.86-4.62a2.29,2.29,0,0,1-1-.22,2.37,2.37,0,0,1-1.16-3.1,2.27,2.27,0,0,1,3-1.13l.11.06a2.31,2.31,0,0,1-1,4.39Zm-9.86-4.62a2.29,2.29,0,0,1-1-.22,2.37,2.37,0,0,1-1.16-3.1,2.27,2.27,0,0,1,3-1.13l.11.06a2.31,2.31,0,0,1-1,4.39Zm-9.86-4.62a2.29,2.29,0,0,1-1-.22,2.37,2.37,0,0,1-1.16-3.1,2.27,2.27,0,0,1,3-1.13l.11.06a2.31,2.31,0,0,1-1,4.39Zm-9.86-4.62a2.42,2.42,0,0,1-1-.21,2.37,2.37,0,0,1-1.17-3.1,2.26,2.26,0,0,1,3-1.14l.11.05a2.31,2.31,0,0,1-1,4.4Zm-9.86-4.62a2.28,2.28,0,0,1-1-.22,2.36,2.36,0,0,1-1.17-3.09,2.26,2.26,0,0,1,3-1.14l.11,0a2.31,2.31,0,0,1-1,4.4Zm-9.86-4.62a2.36,2.36,0,0,1-2.15-3.29,2.26,2.26,0,0,1,3-1.16l.11,0a2.31,2.31,0,0,1-1,4.4Zm-9.86-4.62a2.29,2.29,0,0,1-1-.22,2.35,2.35,0,0,1-1.15-3.1,2.25,2.25,0,0,1,3-1.12l.11.05a2.31,2.31,0,0,1-1,4.39Zm-9.85-4.62a2.33,2.33,0,0,1-1-.22,2.36,2.36,0,0,1-1.16-3.09,2.26,2.26,0,0,1,3-1.13l.11.05a2.31,2.31,0,0,1-1,4.39Z" transform="translate(-122.78 -109.01)"></path>
                  <g class="cls-4">
                    <path d="M863.61,401.27a2.36,2.36,0,0,1-2.37-2.3,2.25,2.25,0,0,1,2.25-2.31h.12a2.31,2.31,0,1,1,0,4.61Zm-10.89,0a2.35,2.35,0,0,1-2.36-2.3,2.25,2.25,0,0,1,2.24-2.31h.12a2.31,2.31,0,1,1,0,4.61Zm-10.88,0a2.35,2.35,0,0,1-2.37-2.3,2.25,2.25,0,0,1,2.24-2.31h.13a2.31,2.31,0,0,1,0,4.61Zm-10.89,0a2.35,2.35,0,0,1-2.37-2.3,2.25,2.25,0,0,1,2.24-2.31H831a2.31,2.31,0,0,1,0,4.61Zm-10.89,0a2.36,2.36,0,0,1-2.37-2.3,2.25,2.25,0,0,1,2.25-2.31h.12a2.31,2.31,0,1,1,0,4.61Zm-10.89,0a2.36,2.36,0,0,1-2.37-2.3,2.25,2.25,0,0,1,2.25-2.31h.12a2.31,2.31,0,1,1,0,4.61Zm-10.89,0a2.35,2.35,0,0,1-2.36-2.3,2.25,2.25,0,0,1,2.24-2.31h.12a2.31,2.31,0,1,1,0,4.61Zm-10.88,0A2.35,2.35,0,0,1,785,399a2.25,2.25,0,0,1,2.24-2.31h.13a2.31,2.31,0,0,1,0,4.61Zm-10.89,0a2.35,2.35,0,0,1-2.37-2.3,2.25,2.25,0,0,1,2.24-2.31h.13a2.31,2.31,0,0,1,0,4.61Zm-10.89,0a2.36,2.36,0,0,1-2.37-2.3,2.25,2.25,0,0,1,2.25-2.31h.12a2.31,2.31,0,1,1,0,4.61Zm-10.89,0a2.36,2.36,0,0,1-2.37-2.3,2.25,2.25,0,0,1,2.25-2.31h.12a2.31,2.31,0,1,1,0,4.61Zm-10.89,0a2.36,2.36,0,0,1-2.37-2.3,2.26,2.26,0,0,1,2.25-2.31h.12a2.31,2.31,0,1,1,0,4.61Zm-10.88,0a2.35,2.35,0,0,1-2.37-2.3,2.25,2.25,0,0,1,2.24-2.31H733a2.31,2.31,0,0,1,0,4.61Z" transform="translate(-122.78 -109.01)"></path>
                  </g>
                  <g class="cls-3">
                    <path d="M720.17,348.09a2.29,2.29,0,0,1-2.11-1.31,2.25,2.25,0,0,1,1.06-3l.11-.05a2.31,2.31,0,0,1,1.95,4.18A2.42,2.42,0,0,1,720.17,348.09Zm9.86-4.61a2.31,2.31,0,0,1-2.11-1.32,2.24,2.24,0,0,1,1.06-3l.11-.06a2.31,2.31,0,0,1,1.95,4.18A2.44,2.44,0,0,1,730,343.48Zm9.86-4.62a2.33,2.33,0,0,1-2.11-1.3,2.27,2.27,0,0,1,1-3.05l.11-.05a2.31,2.31,0,1,1,1,4.4Zm9.86-4.62a2.31,2.31,0,0,1-2.11-1.31,2.25,2.25,0,0,1,1.06-3l.11-.05a2.31,2.31,0,0,1,2,4.18A2.39,2.39,0,0,1,749.75,334.24Zm9.86-4.62a2.3,2.3,0,0,1-2.11-1.31,2.26,2.26,0,0,1,1-3l.12,0a2.31,2.31,0,0,1,2,4.18A2.39,2.39,0,0,1,759.61,329.62Zm9.86-4.61a2.31,2.31,0,0,1-2.11-1.32,2.25,2.25,0,0,1,1.06-3l.11,0a2.31,2.31,0,0,1,2,4.18A2.4,2.4,0,0,1,769.47,325Zm9.86-4.62a2.33,2.33,0,0,1-2.11-1.3,2.26,2.26,0,0,1,1-3l.11-.05a2.31,2.31,0,0,1,2,4.17A2.45,2.45,0,0,1,779.33,320.39Zm9.87-4.62a2.32,2.32,0,0,1-2.12-1.31,2.25,2.25,0,0,1,1.06-3l.11-.05a2.31,2.31,0,0,1,2,4.18A2.38,2.38,0,0,1,789.2,315.77Zm9.85-4.62a2.32,2.32,0,0,1-2.11-1.3,2.25,2.25,0,0,1,1-3l.11-.06a2.31,2.31,0,1,1,.95,4.4Z" transform="translate(-122.78 -109.01)"></path>
                  </g>
                  <g class="cls-22">
                    <path d="M673,295.23a2.28,2.28,0,0,1-1.94-3.47l.06-.1a2.31,2.31,0,1,1,3.9,2.46A2.4,2.4,0,0,1,673,295.23Zm5.81-9.21a2.28,2.28,0,0,1-1.95-3.47l.07-.11a2.31,2.31,0,0,1,3.9,2.47A2.4,2.4,0,0,1,678.81,286Zm5.81-9.21a2.28,2.28,0,0,1-2-3.47l.07-.11a2.31,2.31,0,0,1,3.9,2.47A2.4,2.4,0,0,1,684.62,276.81Zm5.8-9.21a2.28,2.28,0,0,1-1.94-3.47l.06-.1a2.31,2.31,0,1,1,3.9,2.46A2.39,2.39,0,0,1,690.42,267.6Zm5.81-9.21a2.22,2.22,0,0,1-1.19-.34,2.25,2.25,0,0,1-.75-3.13l.06-.11a2.31,2.31,0,0,1,3.9,2.47A2.4,2.4,0,0,1,696.23,258.39Zm5.81-9.21a2.28,2.28,0,0,1-1.94-3.48l.07-.1a2.3,2.3,0,0,1,3.88,2.48A2.4,2.4,0,0,1,702,249.18Zm5.81-9.21a2.31,2.31,0,0,1-1.21-.34,2.26,2.26,0,0,1-.73-3.14l.06-.1a2.31,2.31,0,0,1,3.89,2.48A2.41,2.41,0,0,1,707.85,240Zm5.8-9.21a2.28,2.28,0,0,1-1.94-3.48l.07-.1a2.31,2.31,0,1,1,3.89,2.48A2.41,2.41,0,0,1,713.65,230.76Zm5.81-9.21a2.28,2.28,0,0,1-1.94-3.48l.07-.1a2.31,2.31,0,0,1,3.89,2.48A2.41,2.41,0,0,1,719.46,221.55Z" transform="translate(-122.78 -109.01)"></path>
                  </g>
                  <path d="M550,401.27h-.13a2.31,2.31,0,1,1,0-4.61,2.36,2.36,0,0,1,2.37,2.31A2.25,2.25,0,0,1,550,401.27Zm-10.89,0H539a2.31,2.31,0,0,1,0-4.61,2.36,2.36,0,0,1,2.37,2.31A2.25,2.25,0,0,1,539.13,401.27Zm-10.89,0h-.12a2.31,2.31,0,1,1,0-4.61,2.35,2.35,0,0,1,2.36,2.31A2.25,2.25,0,0,1,528.24,401.27Zm-10.89,0h-.12a2.31,2.31,0,1,1,0-4.61A2.36,2.36,0,0,1,519.6,399,2.26,2.26,0,0,1,517.35,401.27Zm-10.89,0h-.12a2.31,2.31,0,1,1,0-4.61,2.36,2.36,0,0,1,2.37,2.31A2.25,2.25,0,0,1,506.46,401.27Zm-10.89,0h-.12a2.31,2.31,0,1,1,0-4.61,2.36,2.36,0,0,1,2.37,2.31A2.25,2.25,0,0,1,495.57,401.27Zm-10.88,0h-.13a2.31,2.31,0,0,1,0-4.61,2.36,2.36,0,0,1,2.37,2.31A2.25,2.25,0,0,1,484.69,401.27Zm-10.89,0h-.13a2.31,2.31,0,0,1,0-4.61A2.36,2.36,0,0,1,476,399,2.25,2.25,0,0,1,473.8,401.27Zm-10.89,0h-.12a2.31,2.31,0,1,1,0-4.61,2.35,2.35,0,0,1,2.36,2.31A2.25,2.25,0,0,1,462.91,401.27Zm-10.89,0h-.12a2.31,2.31,0,1,1,0-4.61,2.36,2.36,0,0,1,2.37,2.31A2.25,2.25,0,0,1,452,401.27Zm-10.89,0H441a2.31,2.31,0,1,1,0-4.61,2.36,2.36,0,0,1,2.37,2.31A2.25,2.25,0,0,1,441.13,401.27Zm-10.88,0h-.13a2.31,2.31,0,0,1,0-4.61,2.36,2.36,0,0,1,2.37,2.31A2.25,2.25,0,0,1,430.25,401.27Zm-10.89,0h-.13a2.31,2.31,0,0,1,0-4.61A2.36,2.36,0,0,1,421.6,399,2.25,2.25,0,0,1,419.36,401.27Z" transform="translate(-122.78 -109.01)"></path>
                  <circle class="cls-5" cx="641.84" cy="398.97" r="119.09" transform="translate(-139.41 -80.92) rotate(-2.48)"></circle>
                  <path class="cls-6" d="M742.44,399a100.6,100.6,0,1,1-100.6-100.6A100.6,100.6,0,0,1,742.44,399Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-7" d="M650,365a2,2,0,0,0-3,0l-4,4a1.61,1.61,0,0,1-2,.18,29,29,0,0,0-6.59-3,1.59,1.59,0,0,1-1.1-1.52v-6.12a2,2,0,0,0-2.08-2.08h-7.67a2.09,2.09,0,0,0-1.92,1.28l0,0a2.19,2.19,0,0,0-.12.75v5.6a1.6,1.6,0,0,1-1.33,1.58,26.75,26.75,0,0,0-6.67,2.56,1.61,1.61,0,0,1-1.89-.27l-4.45-4.39a2,2,0,0,0-2.89,0L598.9,369a2,2,0,0,0,0,3l4,4a1.62,1.62,0,0,1,.19,2,26.69,26.69,0,0,0-2.42,4.84c-.21.53-.42,1.11-.63,1.75a1.59,1.59,0,0,1-1.52,1.1h-6.11a2,2,0,0,0-2.08,2.08v7.67a2.06,2.06,0,0,0,2.08,2.07H598a1.62,1.62,0,0,1,1.59,1.33,28.86,28.86,0,0,0,2.56,6.77,1.62,1.62,0,0,1-.29,1.88l-4.37,4.36a2,2,0,0,0,0,2.89l5.34,5.4a2.22,2.22,0,0,0,3,0l4-4a1.6,1.6,0,0,1,2.05-.19c.47.3,1,.59,1.5.88l.65.34a16.72,16.72,0,0,0,.09,3.58l-.43-.19q-1-.45-1.83-.9l-.64-.36-3.13,3.18a5.42,5.42,0,0,1-7.43,0l-5.43-5.5a5.14,5.14,0,0,1,0-7.45l3.51-3.5-.35-.75a30.52,30.52,0,0,1-1.43-3.73l-.24-.83h-4.35a5.3,5.3,0,0,1-5.3-5.28v-7.67a5.28,5.28,0,0,1,.39-2,5.39,5.39,0,0,1,2.87-2.88,5.33,5.33,0,0,1,2-.38h5l.3-.79a32.12,32.12,0,0,1,2.06-4.36l-3.08-3.09a5.24,5.24,0,0,1,0-7.51l5.39-5.39a5.15,5.15,0,0,1,7.44,0l3.56,3.51.7-.34a32.21,32.21,0,0,1,4.55-1.67v-4.36a5.3,5.3,0,0,1,5.29-5.29h7.67a5.24,5.24,0,0,1,5.29,5.29v5a36.9,36.9,0,0,1,4.5,2l.65.36,3.09-3.07a5.24,5.24,0,0,1,7.51,0l5.39,5.38a6.2,6.2,0,0,1,.89,1.18,19.75,19.75,0,0,0-3.21-1.36,13.81,13.81,0,0,0-3-.62Zm-27,53.55a7.53,7.53,0,0,0,.11,3.52c.93,3.77,4.64,8.88,9,9.26,2.53.22,6.19-2.4,8.56-3.91a1.63,1.63,0,0,1,1-.22c1,.1,1.3,1,1.72,1.71.88,1.58,1.74,3.15,2.66,4.7a56.49,56.49,0,0,0,4.54,6.51c.47.56,1.66,2,2.59,1.8s2.42-2.71,2.84-3.63a3.76,3.76,0,0,0,.35-1.17,4,4,0,0,0-.66-.1h0c-3.91-.46-3.63-2.41-4.15-5.09-.09-.39-.18-.3-.63-.51a3.84,3.84,0,0,1-1.57-1.25,7.05,7.05,0,0,1-1.13-3.76c-.2-3.56.63-3.42,3.36-4.51a46.87,46.87,0,0,1,10-2.82,50.19,50.19,0,0,1,7.76-.58,57.59,57.59,0,0,1-13.69-13.75,60.4,60.4,0,0,1-9.24-17.64,53.72,53.72,0,0,1-5.33,11.35c-3,4.82-17.26,16.63-18.07,20.1ZM663.8,375.2a1.9,1.9,0,0,1-3.06-2.24c2.27-2.89,4.39-6.07,6.6-9a1.9,1.9,0,0,1,3.06,2.25l-6.6,9Zm20.11,31.29h0a1.9,1.9,0,0,1-1.07-3.64c3.22-.85,6.49-2.06,9.7-2.85a1.9,1.9,0,0,1,1,3.66Zm-2.65-9.4a1.89,1.89,0,0,1-1.41-3.51c2.53-1.06,6.22-2.72,8.74-3.5A1.89,1.89,0,0,1,690,393.6C687.07,394.75,684.18,396,681.26,397.09Zm-4-8.26a1.9,1.9,0,0,1-2.13-3.15c2.8-1.87,5.65-3.75,8.48-5.58a1.9,1.9,0,0,1,2.07,3.19l-8.42,5.54Zm-6.42-7.31a1.9,1.9,0,0,1-2.62-2.74l7.49-7.25a1.9,1.9,0,0,1,2.62,2.74ZM654.28,397.2a9.79,9.79,0,0,1,4.73-.75c4.5.56,7.7,4,7.15,8.38a14.91,14.91,0,0,1-1.81,5.57c.89.86,1.83,1.71,2.85,2.59a35.35,35.35,0,0,0,4.39,3.29,21.34,21.34,0,0,0,4,2c1.75-.35,1.55-2.72,1.38-4.13a27,27,0,0,0-2.79-8.17,68.83,68.83,0,0,0-6.3-10.16,77.45,77.45,0,0,0-7.72-9,44.3,44.3,0,0,0-5-4.34c-1.36-1-3.79-2.58-5.53-2.63-.85,0-1,.32-1.06,1.15a13.87,13.87,0,0,0,.58,4.57,39.87,39.87,0,0,0,2.77,7.12c.49,1,2.35,4.63,2.35,4.54Zm13.4,24.53a42.78,42.78,0,0,0-16.4,3.71c0,.33,0,.67,0,1,0,.51.21,1.81.74,2.08a4.21,4.21,0,0,1,2.09,1.52h0c.74,1.2.25,3.67,1.9,3.88h0c2.58.3,3.49,1.51,3.48,3.09,0,2-2.39,6.2-4.28,7.51a4.17,4.17,0,0,1-1.58.68c-2.39.44-4.45-1.65-5.81-3.35a56,56,0,0,1-4.52-6.5c-.79-1.33-1.61-2.8-2.44-4.3l0,0c-.62.38-1.21.8-1.83,1.19-2.2,1.42-4.28,2.6-7.31,2.29-5.81-.59-10.73-6.85-11.82-12.25a10.62,10.62,0,0,1,0-4.49c1.78-7.57,18.48-15.65,24.46-34.68v0c.75-2.41,1.44-6,4.39-6.37a9.83,9.83,0,0,1,5.79,1.6l0,0a39.32,39.32,0,0,1,7.69,6.15A80.53,80.53,0,0,1,670.4,394a72.48,72.48,0,0,1,6.66,10.79,29.81,29.81,0,0,1,3,9,11.79,11.79,0,0,1,0,3.14c-.43,3.07-1.87,4.26-5.1,4.64C672.9,421.8,669.9,421.66,667.68,421.73Zm-34.77-44.49h0a16.53,16.53,0,0,1,6,4.26c-.46,1.13-1,2.21-1.51,3.25a13.19,13.19,0,0,0-5.72-4.56,13.56,13.56,0,0,0-13.87,2.07,13,13,0,0,0-2.49,2.77,13.81,13.81,0,0,0-1.25,2.32,13.54,13.54,0,0,0,1.25,12.77,13.14,13.14,0,0,0,3.59,3.59,13.73,13.73,0,0,0,2,1.09c-.79.83-1.54,1.65-2.24,2.48-.52-.28-1-.58-1.51-.91a16.41,16.41,0,0,1-2.46-2h0a16.93,16.93,0,0,1-2-2.46,16.7,16.7,0,0,1-1.54-15.81h0a16.68,16.68,0,0,1,21.82-8.84Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-7" d="M528.88,154.18v-5.59l-2-2H523l-2,2v5.59H502v26.89h45.8V154.18Zm-6.44-5,1.15-1.14h2.67l1.14,1.14v7.28h-5V149.2Zm23.9,30.39H503.5V155.66H521V158h7.92v-2.3h17.46v23.93Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-7" d="M504.92,178.13h15.61V159.77H504.92Zm4.31-11.3a3.5,3.5,0,1,1,4.62,3.31l.09,1.43a5.84,5.84,0,0,1,4.58,5.08H506.93a5.85,5.85,0,0,1,4.59-5.08l.08-1.43A3.49,3.49,0,0,1,509.23,166.83Zm9.82-5.58v12.37a7.36,7.36,0,0,0-3.16-2.94,5,5,0,1,0-6.32,0,7.44,7.44,0,0,0-3.17,2.94V161.25Z" transform="translate(-122.78 -109.01)"></path>
                  <rect class="cls-7" x="403.74" y="52.97" width="16.79" height="1.48"></rect>
                  <rect class="cls-7" x="403.74" y="57.91" width="16.79" height="1.48"></rect>
                  <g class="cls-4">
                    <text class="cls-8" transform="translate(195 40)" font-family="Poppins" font-weight="800">
                      <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#point1">Identification</a>
                    </text>
                    <text class="cls-18" transform="translate(254 65)" font-family="Poppins" font-weight="800">
                      <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#point1">Click Here</a>
                    </text>
                  </g>
                  <g class="cls-4">
                    <text class="cls-8" transform="translate(82 145)" font-family="Poppins" font-weight="800">
                      <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#point2">Standard Deep <tspan x="68" y="25">Profiling</tspan>
                      </a>
                    </text>
                    <text class="cls-18" transform="translate(160 192)" font-family="Poppins" font-weight="800">
                      <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#point2">Click Here</a>
                    </text>
                  </g>
                  <g class="cls-4">
                    <text class="cls-8" transform="translate(708 40)" font-family="Poppins" font-weight="800">
                      <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#point10">KOL Network</a>
                    </text>
                    <text class="cls-18" transform="translate(708 65)" font-family="Poppins" font-weight="800">
                      <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#point10">Click Here</a>
                    </text>
                  </g>
                  <g class="cls-4">
                    <text class="cls-8" transform="translate(812 145)" font-family="Poppins" font-weight="800">
                      <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#point9">KOL Influence <tspan x="0" y="25">Mapping</tspan>
                      </a>
                    </text>
                    <text class="cls-18" transform="translate(812 192)" font-family="Poppins" font-weight="800">
                      <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#point9">Click Here</a>
                    </text>
                  </g>
                  <g class="cls-4">
                    <text class="cls-8" transform="translate(64 275)" font-family="Poppins" font-weight="800">
                      <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#point3">Standard <tspan x="-64" y="25">Ranking/Rating</tspan>
                      </a>
                    </text>
                    <text class="cls-18" transform="translate(85 325)" font-family="Poppins" font-weight="800">
                      <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#point3">Click Here</a>
                    </text>
                  </g>
                  <g class="cls-4">
                    <text class="cls-8" transform="translate(882 275)" font-family="Poppins" font-weight="800">
                      <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#point8">Recruitment of KOLs <tspan x="0" y="25">for Engagements</tspan>
                      </a>
                    </text>
                    <text class="cls-18" transform="translate(882 325)" font-family="Poppins" font-weight="800">
                      <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#point8">Click Here</a>
                    </text>
                  </g>
                  <g class="cls-4">
                    <text class="cls-8" transform="translate(5 400)" font-family="Poppins" font-weight="800">
                      <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#point4">Custom Deep Profiling <tspan x="22" y="25">and Ranking/Rating</tspan>
                      </a>
                    </text>
                    <text class="cls-18" transform="translate(158 450)" font-family="Poppins" font-weight="800">
                      <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#point4">Click Here</a>
                    </text>
                  </g>
                  <g class="cls-4">
                    <text class="cls-8" transform="translate(814 400)" font-family="Poppins" font-weight="800">
                      <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#point7">Interviews/Podcasts <tspan x="0" y="25">with KOLs</tspan>
                      </a>
                    </text>
                    <text class="cls-18" transform="translate(814 450)" font-family="Poppins" font-weight="800">
                      <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#point7">Click Here</a>
                    </text>
                  </g>
                  <g class="cls-4">
                    <text class="cls-8" transform="translate(165 515)" font-family="Poppins" font-weight="800">
                      <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#point5">Classification of <tspan x="35" y="25">clinical KOLs</tspan>
                      </a>
                    </text>
                    <text class="cls-18" transform="translate(255 562)" font-family="Poppins" font-weight="800">
                      <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#point5">Click Here</a>
                    </text>
                  </g>
                  <g class="cls-4">
                    <text class="cls-8" transform="translate(704 515)" font-family="Poppins" font-weight="800">
                      <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#point6">Long-term KOL <tspan x="0" y="25">Engagements</tspan>
                      </a>
                    </text>
                    <text class="cls-18" transform="translate(704 565)" font-family="Poppins" font-weight="800">
                      <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#point6">Click Here</a>
                    </text>
                  </g>
                  <path class="cls-7" d="M424.17,283.44h-8.25a.72.72,0,0,0-.67.75.69.69,0,0,0,.65.74h8.27Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-7" d="M415.25,289.5a.69.69,0,0,0,.65.74h8.27v-1.48h-8.25A.71.71,0,0,0,415.25,289.5Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-7" d="M411.16,262.36h15.57v8.9a1.11,1.11,0,0,0,1.11,1.1H437v7.2h2.2v-8.51a1.1,1.1,0,0,0-.79-1.06l-9.7-9.43a1,1,0,0,0-.84-.4H410.93a2,2,0,0,0-2,2v33.7a2,2,0,0,0,2,2H424.2v-2.2h-13ZM428.93,264l6.58,6.16h-6.58Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-7" d="M443.39,282.23H431.14a3.13,3.13,0,0,0-3.13,3.12v12.93a3.13,3.13,0,0,0,3.13,3.12h12.25a3.12,3.12,0,0,0,3.12-3.12V285.35A3.12,3.12,0,0,0,443.39,282.23Zm-6.13,15.4c-3.41-1.25-5.43-4.3-5.28-10a7.45,7.45,0,0,0,5.26-1.62,8.79,8.79,0,0,0,5.29,1.7C442.79,293.1,440.8,296.29,437.26,297.63Zm0-10.29a6.75,6.75,0,0,0,4.07,1.31c.21,4.17-1.34,6.62-4.05,7.65l-.05,0v-8.91Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-7" d="M415.92,269h4.19a.71.71,0,0,0,.67-.74.69.69,0,0,0-.66-.74h-4.2a.71.71,0,0,0-.67.74.68.68,0,0,0,.65.74Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-7" d="M429.49,278.87a.7.7,0,0,0-.66-.74H415.92a.71.71,0,0,0-.67.74.69.69,0,0,0,.66.74h12.91A.71.71,0,0,0,429.49,278.87Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-7" d="M415.91,274.3h7.64a.75.75,0,0,0,0-1.49h-7.64a.72.72,0,0,0-.67.75A.7.7,0,0,0,415.91,274.3Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-7" d="M337.46,399.47a9.08,9.08,0,0,0,5.38-1.75,8.91,8.91,0,0,0,3.33-4.58h0a8.73,8.73,0,0,0,.45-2.83,9.18,9.18,0,0,0-9.17-9.17,8.93,8.93,0,0,0-5.39,1.75,9.17,9.17,0,0,0,5.4,16.59Zm5.08-3.45-2.22-3-.88-1.23,5,1.64A7,7,0,0,1,342.54,396ZM345,390.3a7.09,7.09,0,0,1-.17,1.63l-6.72-2.18v-7.06A7.66,7.66,0,0,1,345,390.3Zm-12.22-5.83a7.49,7.49,0,0,1,4.2-1.79v7.62s0,.08,0,.12h0a.43.43,0,0,0,0,.05l0,.06h0l0,.06v0h0a.27.27,0,0,0,.06.1l4.47,6.16a7.61,7.61,0,0,1-3.85,1,7.7,7.7,0,0,1-7.65-8.49A7.18,7.18,0,0,1,332.78,384.47Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-7" d="M352.4,401.29h4.12a.75.75,0,0,0,.75-.76V381.76a.75.75,0,0,0-.75-.76H352.4a.76.76,0,0,0-.76.76v18.77A.76.76,0,0,0,352.4,401.29Zm1.49-19.16h2.26V399h-2.26V382.13Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-7" d="M359.16,400.17h4.12a.76.76,0,0,0,.76-.76v-8.63a.76.76,0,0,0-.76-.76h-4.12a.76.76,0,0,0-.76.76v8.63A.76.76,0,0,0,359.16,400.17Zm1.5-9h2.25V399h-2.25Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-7" d="M370,386.64h-4.12a.76.76,0,0,0-.75.76v13.13a.76.76,0,0,0,.75.76H370a.76.76,0,0,0,.76-.76V387.4A.76.76,0,0,0,370,386.64ZM368.55,399h-2.26V387.76h2.26Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-7" d="M369.37,408.47a1.18,1.18,0,0,0-1.18,1.18,1.09,1.09,0,0,0,0,.18l-6.61,7.8h-.27l-6.52-5.2a1.19,1.19,0,0,0-1-1l-6.64-7.84v0a1.19,1.19,0,0,0-2.35-.22l-6.23,4.11a1.13,1.13,0,0,0-.45-.09,1.32,1.32,0,0,0-.52.12l-6-2.37a1.19,1.19,0,1,0-1.11,1.59,1.19,1.19,0,0,0,.6-.16l5.9,2.33a1.19,1.19,0,0,0,2.3-.07l6.26-4.13a1.16,1.16,0,0,0,.42.08l.18,0,6.34,7.49a1.15,1.15,0,0,0-.06.37,1.19,1.19,0,0,0,1.19,1.19,1.15,1.15,0,0,0,.37-.06l6.28,5v.06a1.19,1.19,0,1,0,2.37,0v-.08l6.68-7.89h0a1.19,1.19,0,1,0,0-2.37Z" transform="translate(-122.78 -109.01)"></path>
                  <g id="Layer_2" data-name="Layer 2">
                    <g id="Interface-Light">
                      <g id="interface-light-ranking-medal">
                        <line class="cls-15" x1="301.72" y1="404.49" x2="301.72" y2="398.49"></line>
                        <line class="cls-15" x1="300.87" y1="399.62" x2="302.07" y2="398.42"></line>
                        <path class="cls-15" d="M425.49,499.25l2.21,1.69a1,1,0,0,0,.7.22l2.82-.14a1,1,0,0,1,1,.72l.73,2.62a1,1,0,0,0,.43.55l2.4,1.49a.93.93,0,0,1,.39,1.2l-1,2.48a.94.94,0,0,0,0,.7l1,2.53a.92.92,0,0,1-.38,1.2L433.4,516a1,1,0,0,0-.43.55l-.73,2.62a1,1,0,0,1-1.05.72l-2.73-.18a1,1,0,0,0-.7.21l-2.21,1.7a1.07,1.07,0,0,1-1.27,0l-2.21-1.7a1,1,0,0,0-.69-.21l-2.82.13a1,1,0,0,1-1.05-.72l-.73-2.62a1,1,0,0,0-.43-.55l-2.4-1.49a.92.92,0,0,1-.4-1.2l1-2.53a1,1,0,0,0,0-.69l-1-2.49a.93.93,0,0,1,.39-1.2l2.4-1.49a1,1,0,0,0,.44-.55l.73-2.61a1,1,0,0,1,1-.72l2.82.13a1,1,0,0,0,.7-.22l2.17-1.64A1,1,0,0,1,425.49,499.25Z" transform="translate(-122.78 -109.01)"></path>
                        <circle class="cls-15" cx="302.07" cy="401.42" r="5.4"></circle>
                        <line class="cls-15" x1="319.47" y1="420.02" x2="310.23" y2="407.42"></line>
                        <line class="cls-15" x1="319.47" y1="420.02" x2="311.07" y2="418.82"></line>
                        <line class="cls-15" x1="307.47" y1="424.82" x2="311.07" y2="418.82"></line>
                        <line class="cls-15" x1="307.47" y1="424.82" x2="304.43" y2="411.38"></line>
                        <line class="cls-15" x1="284.67" y1="420.02" x2="293.91" y2="407.42"></line>
                        <line class="cls-15" x1="284.67" y1="420.02" x2="293.07" y2="418.82"></line>
                        <line class="cls-15" x1="296.67" y1="424.82" x2="293.07" y2="418.82"></line>
                        <line class="cls-15" x1="296.67" y1="424.82" x2="299.72" y2="411.38"></line>
                      </g>
                    </g>
                  </g>
                  <path class="cls-7" d="M506.58,643H520.8a2.17,2.17,0,0,0,1.77-2,2.14,2.14,0,0,0-1.77-2H508.49a12.45,12.45,0,0,1,12.31-10.44,9,9,0,1,0-6-2.38,16,16,0,0,0-10,14.81A2.17,2.17,0,0,0,506.58,643Zm14.22-28.66a5.33,5.33,0,1,1-5.33,5.33A5.33,5.33,0,0,1,520.8,614.34Zm17.76,17.77,5.34.78-4.45,3.66,1.39,6.22-4.94-3.55L531,642.77l1.39-6.22-4.45-3.66,5.33-.78,2.67-5.33Z" transform="translate(-122.78 -109.01)"></path>
                  <line class="cls-16" x1="633.22" y1="55.23" x2="633.22" y2="60.23"></line>
                  <polyline class="cls-16" points="630.41 61.16 633.25 59.46 636.09 61.16"></polyline>
                  <path class="cls-16" d="M757.81,152.24a2.91,2.91,0,0,0,2.18,2.87,4.35,4.35,0,0,1,3,3.13H749.36a4.18,4.18,0,0,1,2.86-3.13,3.07,3.07,0,0,0,2.18-2.87h0" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-16" d="M756,153.41h0a3,3,0,0,1-3-3v-3a3,3,0,0,1,3-3h0a3,3,0,0,1,3,3v3A3,3,0,0,1,756,153.41Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-16" d="M769.15,175.24a2.91,2.91,0,0,0,2.18,2.87,4.34,4.34,0,0,1,3,3.13H760.7a4.18,4.18,0,0,1,2.86-3.13,3.07,3.07,0,0,0,2.18-2.87h0" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-16" d="M767,176.09h0a3,3,0,0,1-3-3v-3a3,3,0,0,1,3-3h0a3,3,0,0,1,3,3v3A3,3,0,0,1,767,176.09Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-16" d="M746.46,175.24a2.91,2.91,0,0,0,2.19,2.87,4.35,4.35,0,0,1,3,3.13H737.87a4.19,4.19,0,0,1,2.87-3.13,3.08,3.08,0,0,0,2.18-2.87h0" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-16" d="M745,176.09h0a3,3,0,0,1-3-3v-3a3,3,0,0,1,3-3h0a3,3,0,0,1,3,3v3A3,3,0,0,1,745,176.09Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-7" d="M852.2,262a5.45,5.45,0,1,1-5.45,5.45A5.46,5.46,0,0,1,852.2,262Zm-8.78,20a1.64,1.64,0,0,1,.69-.23c.42,0,.68.27.89.69V298h15V282.46c-.23-.41,0-.69.46-.69s.54.69.54.69V298h5V281.09s-3.16-6.82-6.9-7.09h-1.37l-4,6.5-.48-4.66.66-.84H851l.65.84-.51,4.69-4-6.53h-1.4a6.7,6.7,0,0,0-6.69,6.69V297l5,1V282Zm29-7a8,8,0,1,0-8.46-7.47A7.95,7.95,0,0,0,872.46,275Zm-2.27-9.61c-.23-.43.4-.68.73-1s1.29-1.15,1.19-1.42-1-1.08-1.49-.89a5.9,5.9,0,0,0-.79.74c0-.23,0-.34,0-.55s-.28-.26-.27-.37.64-.71.78-.89c-.13-.07-.53-.37-.64-.33s-.58.24-.87.37a1.73,1.73,0,0,0,0-.27,8.11,8.11,0,0,1,1.75-.63l.55.2.41.43.41.39a1.43,1.43,0,0,0,.34.1c.13,0,.51-.54.51-.54l-.17-.38,0-.34a7,7,0,0,1,3,1,4.77,4.77,0,0,0-.53.1c-.08,0-.51,0-.49.23s.78.75,1.1,1.29,1.24.89,1.41,1.51-.1,1.63,0,2.48a3.79,3.79,0,0,0,1,1.72,1.54,1.54,0,0,0,.74,0,7,7,0,0,1-1.66,3.36,6.82,6.82,0,0,1-3.52,2.16,3,3,0,0,1,.79-1.22,3.28,3.28,0,0,0,.71-1,5,5,0,0,1,.48-.95c.24-.44-.75-1.05-1.08-1.15a9.56,9.56,0,0,1-1.92-1c-.47-.28-1.87.37-2.41.16a7.11,7.11,0,0,1-1.59-.89c-.65-.43-.47-1.35-.51-2,.49,0,1.16-.21,1.52.16.1.13.48.64.71.43S870.26,265.51,870.19,265.37Zm-3.92-2.51c0,.35.22.61.22.85A3,3,0,0,0,867,266a2.94,2.94,0,0,1,.43,1.1c.13.34.54.51.84.71.59.38,1.16.88,1.8,1.22.4.23.65.35.58.84a2.85,2.85,0,0,1-.26,1,2,2,0,0,0,.38.86c.33.26.63.53,1,.77.53.39,0,1-.21,1.56a7.14,7.14,0,0,1-4.23-1.76,7,7,0,0,1-2.37-4.84A6.51,6.51,0,0,1,866.27,262.86Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-7" d="M931.07,388.69A4.09,4.09,0,1,0,927,384.6,4.09,4.09,0,0,0,931.07,388.69Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-7" d="M940.87,379a1.8,1.8,0,0,0-1.32-.6c-.89,0-1.53.64-1.72,1.72l-.89,5.55-.07.17-3.25,3.47h-6l-3.25-3.47,0-.11-.91-5.61a1.81,1.81,0,0,0-1.72-1.72,1.86,1.86,0,0,0-1.38.64,1.4,1.4,0,0,0-.33,1.15l.89,5.54a3.94,3.94,0,0,0,1,2.5l3.75,4v5.08h-5.92l.65-2.48a2.7,2.7,0,0,1,.69-1.16l.58-.52a1.68,1.68,0,1,0-.63-1.31,1.53,1.53,0,0,0,0,.3l-.75.67a3.92,3.92,0,0,0-1,1.75l-.71,2.75h-.26c-.17.19-.33.26-.44.39a.56.56,0,0,0-.1.47l.82,4a5.59,5.59,0,0,0,.71,1.18h1.09l1.34,14h-.84a1.22,1.22,0,0,0-1.22,1.22V420a1.23,1.23,0,0,0,1.22,1.23h16.56a1.23,1.23,0,0,0,1.22-1.23v-1.55a1.22,1.22,0,0,0-1.22-1.22h-.67l1.34-14h.84a5.59,5.59,0,0,0,.71-1.18l.82-4a.56.56,0,0,0-.1-.47,4.52,4.52,0,0,0-.44-.39h-4.28v-5.08l3.75-4a4,4,0,0,0,1-2.5l.9-5.54h0A1.53,1.53,0,0,0,940.87,379Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-7" d="M871.33,514.93c1.17,2.47,5.9,2.6,6.95-.18,3.21,2.06,5.27,1.67,5.25,5.25H871.38a11.89,11.89,0,0,1-1.85,5.34l5.77,6.28-4,3.63-5.57-6.11a13.31,13.31,0,0,1-18.46-3.72,14,14,0,0,1-1.93-4.42H832.9c.35-4.78,1.23-4.22,5.18-6.69,1.08,2.83,6.32,3,7.47,0l.06,0a13.31,13.31,0,0,1,25.72.58Zm-17.65,2.74a3,3,0,0,1-1.4-.88c2.21-.83,1-4.5,1.64-6.36a3.73,3.73,0,0,1,5.65-1.83c1.32-.14,2.71.55,3,2.65C862.81,513,862,516,864,517a3.3,3.3,0,0,1-1.54.74A16.44,16.44,0,0,1,860,518v.73l.85,1.35-2.73,2.13L855.4,520l.6-1.29V518A10.68,10.68,0,0,1,853.68,517.67Zm8.32,3.08a6,6,0,0,0-1.18-1.83c4.58,1.77,4.18.57,5.12,4.28q.13.49.3,1.14c-3.71,4.76-12.54,4.76-16.48,0,.11-.41.21-.83.3-1.16.93-3.66.51-2.48,5.15-4.26a6.24,6.24,0,0,0-1.18,1.83l1.19,0,2.72,2.18,2.85-2.18,1.21,0ZM866.75,510a11.8,11.8,0,0,0-16.7,0h0a12,12,0,0,0,0,16.72A11.82,11.82,0,0,0,867,510.23l-.23-.23ZM840,514.09c-.67-.21-.61-.42-.51-.61a2.59,2.59,0,0,1-1-1.48h0c-.13-.34-.25-.37-.36-.43a1.06,1.06,0,0,1-.39-.47c-.18-.42-.32-1.5.14-1.81l.16-.06v-.12a.93.93,0,0,1-.28-.76c0-1,0-2.26-.86-2.5l-.35-.11.23-.26a13.57,13.57,0,0,1,2.06-2.09,5.14,5.14,0,0,1,2.37-1.17,2.88,2.88,0,0,1,2.32.65,4,4,0,0,1,.61.62,2.63,2.63,0,0,1,1.86,1.08,3.76,3.76,0,0,1,.6,1.24,4,4,0,0,1,.16,1.38,3.32,3.32,0,0,1-1,2.24.78.78,0,0,1,.3.07.74.74,0,0,1,.26.92c-.09.28-.2.6-.3.87s-.32.44-.69.41a2.45,2.45,0,0,1-1,1.89l.13.44c-.36,1.73-4.12,1.91-4.46.1Zm32.44.19a1.57,1.57,0,0,1,.17-.57,2.34,2.34,0,0,1-.92-1.71h0a.63.63,0,0,1-.33-.09.87.87,0,0,1-.37-.45c-.17-.38-.3-1.4.12-1.69l-.08-.06v-.11c0-.2,0-.46,0-.72,0-1,0-2.12-.83-2.35l-.33-.1.22-.27a12.78,12.78,0,0,1,1.93-2,5,5,0,0,1,2.24-1.09,2.74,2.74,0,0,1,2.18.61,4.62,4.62,0,0,1,.58.59,2.44,2.44,0,0,1,1.74,1,3.64,3.64,0,0,1,.57,1.15,4.06,4.06,0,0,1,.15,1.3,3.13,3.13,0,0,1-.91,2.1.64.64,0,0,1,.28.07.71.71,0,0,1,.26.86c-.09.26-.2.57-.3.83s-.29.41-.64.37a2.24,2.24,0,0,1-.94,1.77l.12.41c-.34,1.62-3.89,1.8-4.85.09Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-7" d="M757,632h0v.22S757.22,632.58,757,632Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-7" d="M753.53,622.69a2.1,2.1,0,0,0-1.21-1.16c.93,2-1.73,2.77-1.81.36a1.88,1.88,0,0,0-.23,2.7,1.82,1.82,0,0,1,.61,1.39c0,.52-.06,3.46-.1,4a1.51,1.51,0,0,1-.08.49,5,5,0,0,1-.71,1h0a1.71,1.71,0,0,0-.35,1.8,2.14,2.14,0,0,0,1.21,1.17c-.93-2,1.73-2.78,1.81-.36a1.87,1.87,0,0,0,.23-2.7,3,3,0,0,1-.53-.89,1.41,1.41,0,0,1,0-.43c0-.56.06-3.5.08-4.09C752.42,624.86,754.14,624.29,753.53,622.69Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-17" d="M757.51,626.74c-.08,0-.07,0,0,0H758v0a2.1,2.1,0,0,1-1-.72h-.76s-.36.52-.26.72v5.5c-.1.2.06.36.26-.22H757v-.12s0,0,.08,0l.07,0a2.6,2.6,0,0,0,1.27-1c.29,0,.29-.53.38-.83h.2v-2.54a13.42,13.42,0,0,0-1.48-.71S757.52,626.74,757.51,626.74Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-7" d="M775.54,639h-5.18a.85.85,0,0,0,.64-.83v-24.3a.87.87,0,0,0-.87-.87H733.87a.87.87,0,0,0-.87.87v24.3a.88.88,0,0,0,.65.83h-5.48a1,1,0,0,0,0,2h47.37a1,1,0,0,0,0-2Zm-22.41,1H750.2a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.93a.5.5,0,1,1,0,1ZM769,637H735V614h34Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-7" d="M747.16,632H747v.22S747.35,632.57,747.16,632Z" transform="translate(-122.78 -109.01)"></path>
                  <path class="cls-7" d="M744.46,631.16a2.87,2.87,0,0,0,1.41,1.05l.08,0s.06,0,0,0h0c0,.19.2.35.39-.22H747v-5.29a.66.66,0,0,0,.16-.71h-.77c-.19.36-.39.71-.39.71v0a.08.08,0,0,0,0,0h-.06c-.52.17-.89.9-.89.9v-2.92c0-7.18,14-7.26,14,0v-.3c0-9-15-9.1-15,0V630h0A5.26,5.26,0,0,0,744.46,631.16Z" transform="translate(-122.78 -109.01)"></path>
                </svg>

              </div>
            </div>
          </div>
        </section>
        <section class="section bg-grey-light">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-lg-12">
                <div class="text-start mb-4">
                  <h3 class="mb-0 fw-bold lh-base fs-4">MedTech Gurus KOL Platform</h3>
                </div>
              </div>
            </div>
            <div class="row justify-content-center gy-2">
              <div class="col-lg-4 col-md-6">
                <div class="shadow-none h-100 overflow-hidden">
                  <div class="grid-row pb-2 d-flex align-items-center justify-content-start border-bottom-2 mb-2">
                    <div class="avatar-sm-2 me-4">
                      <div class="bg-secbrand rounded-0 p-2">
                        <img class="img-fluid" src={require("./Assets/Images/Picture1.webp")} />
                      </div>
                    </div>
                    <h5 class="fs-18 fw-bold m-0">OVERVIEW</h5>
                  </div>
                  <div class="card rounded-0 h-100">
                    <div class="card-body p-0">
                      <img src={require("../src/Assets/Images/Overview.png")} alt="" class="img-fluid w-100" />
                      <ol class="fw-normal ps-4 py-2 pe-2 text-secbrand mt-2 lh-base fs-14">
                        <li>Profile with specialty, sub-specialty, expertise, personal information, biography, etc.</li>
                        <li>Recommended engagement types (among clinical trials, publications, guidelines, events/conferences, advisory board, etc.)</li>
                        <li>Industry/competitor alignment analytics.</li>
                        <li>Global collaboration/peers network mapping.</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="shadow-none h-100 overflow-hidden">
                  <div class="grid-row pb-2 d-flex align-items-center justify-content-start border-bottom-2 mb-2">
                    <div class="avatar-sm-2 me-4">
                      <div class="bg-secbrand rounded-0 p-2">
                        <img class="img-fluid" src={require("../src/Assets/Images/Picture2.png")} />
                      </div>
                    </div>
                    <h5 class="fs-18 fw-bold m-0">LEVEL OF EXPERTISE</h5>
                  </div>
                  <div class="card rounded-0 h-100">
                    <div class="card-body p-0">
                      <img src={require("../src/Assets/Images/expertise.png")} alt="" class="img-fluid w-100" />
                      <ol class="fw-normal ps-4 py-2 pe-2 text-secbrand mt-2 lh-base fs-14">
                        <li>Standard ranking of the KOLs among peers in any given clinical procedure, disease condition, or specialty area by region based on advanced analytics using objective automated metrics.</li>
                        <li>Custom peer ranking based on client requirements</li>
                        <li>Identification of rock stars (top established KOLs), rising stars (relatively new and rising KOLs), and declining stars (recently inactive KOLs) based on advanced analytics.</li>
                        <li>Social media influence and categorization of a KOL as a DOL (digital opinion leader).</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="shadow-none h-100 overflow-hidden">
                  <div class="grid-row pb-2 d-flex align-items-center justify-content-start border-bottom-2 mb-2">
                    <div class="avatar-sm-2 me-4">
                      <div class="bg-secbrand rounded-0 p-2">
                        <img class="img-fluid" src={require("./Assets/Images/Picture3.png")} />
                      </div>
                    </div>
                    <h5 class="fs-18 fw-bold m-0">DEEP PROFILE</h5>
                  </div>
                  <div class="card rounded-0 h-100">
                    <div class="card-body p-0">
                      <img src={require("../src/Assets/Images/deepprofile.png")} alt="" class="img-fluid w-100" />
                      <ol class="fw-normal ps-4 py-2 pe-2 text-secbrand mt-2 lh-base fs-14">
                        <li>In-depth profile including details of the following:
                          <ul class="fw-normal lh-base">
                            <li class="d-flex align-items-start"><img src={require('../src/Assets/Images/1.png')} class="me-2 mt-1" /> <span>Publications</span></li>
                            <li class="d-flex align-items-start"><img src={require('../src/Assets/Images/2.png')} class="me-2 mt-1" /> <span>Clinical trials</span></li>
                            <li class="d-flex align-items-start"><img src={require('../src/Assets/Images/3.png')} class="me-2 mt-1" /> <span>Guidelines</span></li>
                            <li class="d-flex align-items-start"><img src={require('../src/Assets/Images/4.png')} class="me-2 mt-1" /> <span>Speakerships at Events/Conferences</span></li>
                            <li class="d-flex align-items-start"><img src={require('../src/Assets/Images/5.png')} class="me-2 mt-1" /> <span>Advisory board memberships</span></li>
                            <li class="d-flex align-items-start"><img src={require('../src/Assets/Images/6.png')} class="me-2 mt-1" /> <span>Membership at Clinical Societies</span></li>
                            <li class="d-flex align-items-start"><img src={require('../src/Assets/Images/7.png')} class="me-2 mt-1" /> <span>Sunshine payment details</span></li>
                            <li class="d-flex align-items-start"><img src={require('../src/Assets/Images/8.png')} class="me-2 mt-1" /> <span>Grant details and more</span></li>
                          </ul>
                        </li>
                        <li>Custom deep profiling as per client requirements</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="section">
          <div class="container">
            <div class="justify-content-center row">
              <div class="col-lg-12">
                <div class="text-start mb-4">
                  <h3 class="mb-0 fw-bold lh-base fs-4">Types of KOLs/DOLs</h3>
                </div>
              </div>
            </div>
            <div class="justify-content-center row g-4">
              <div class="col-md-6 col-lg-4">
                <div class="shadow text-center card-overlay card rounded-4 overflow-hidden">
                  <img class="card-img img-fluid" src={require("../src/Assets/Images/HCPsClinical-KOLs.jpg")} alt="HCPs/Clinical KOLs" />
                  <div class="py-4 card-body card-img-overlay p-0 d-flex justify-content-center bg-secbrand-50">
                    <h3 class="fw-bold fs-5 pt-1 d-flex align-items-center text-white">HCPs/Clinical KOLs</h3>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-4">
                <div class="shadow text-center card-overlay card rounded-4 overflow-hidden">
                  <img class="card-img img-fluid" src={require("../src/Assets/Images/HTA-Experts.jpg")} alt="HTA Experts" />
                  <div class="py-4 card-body card-img-overlay p-0 d-flex justify-content-center bg-secbrand-50">
                    <h3 class="fw-bold fs-5 pt-1 d-flex align-items-center text-white">HTA Experts</h3>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-4">
                <div class="shadow text-center card-overlay card rounded-4 overflow-hidden">
                  <img class="card-img img-fluid" src={require("../src/Assets/Images/Payers.jpg")} alt="Payers" />
                  <div class="py-4 card-body card-img-overlay p-0 d-flex justify-content-center bg-secbrand-50">
                    <h3 class="fw-bold fs-5 pt-1 d-flex align-items-center text-white">Payers</h3>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-4">
                <div class="shadow text-center card-overlay card rounded-4 overflow-hidden">
                  <img class="card-img img-fluid" src={require("../src/Assets/Images/Hospital-Procurement-Experts.jpg")} alt="Hospital Procurement Experts" />
                  <div class="py-4 card-body card-img-overlay p-0 d-flex justify-content-center bg-secbrand-50">
                    <h3 class="fw-bold fs-5 pt-1 d-flex align-items-center text-white">Hospital Procurement Experts</h3>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-4">
                <div class="shadow text-center card-overlay card rounded-4 overflow-hidden">
                  <img class="card-img img-fluid" src={require("../src/Assets/Images/Advocacy-Group.jpg")} alt="Advocacy Group Experts" />
                  <div class="py-4 card-body card-img-overlay p-0 d-flex justify-content-center bg-secbrand-50">
                    <h3 class="fw-bold fs-5 pt-1 d-flex align-items-center text-white">Advocacy Group Experts</h3>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-4">
                <div class="shadow text-center card-overlay card rounded-4 overflow-hidden">
                  <img class="card-img img-fluid" src={require("../src/Assets/Images/MedTech-Industry.jpg")} alt="MedTech Industry Experts" />
                  <div class="py-4 card-body card-img-overlay p-0 d-flex justify-content-center bg-secbrand-50">
                    <h3 class="fw-bold fs-5 pt-1 d-flex align-items-center text-white">MedTech Industry Experts</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="section pt-0">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-lg-12">
                <div class="text-start mb-4">
                  <h3 class="mb-0 fw-bold lh-base fs-4">Type of HCPs/Clinical KOLs</h3>
                </div>
              </div>
            </div>
            <div class="justify-content-center row g-4">
              <div class="col-md-12 col-lg-6">
                <div class="text-start mb-2">
                  <h5 class="fs-16 text-uppercase text-danger">By specialty</h5>
                  <h3 class="mb-0 fw-bold lh-base fs-4">50+ Clinical specialty such as:</h3>
                </div>
                <ul class="list-group list-group-flush">
                  <li class="list-group-item p-1">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <img src={require("../src/Assets/Images/Cardiothoracic-surgeons.png")} class="icon-box" />
                      </div>
                      <div className="flex-grow-1 ms-2"> Neurosurgeons </div>
                    </div>
                  </li>
                  <li class="list-group-item p-1">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <img src={require("../src/Assets/Images/Interventional-Neuroradiologists.png")} class="icon-box" />
                      </div>
                      <div className="flex-grow-1 ms-2">Interventional Neuroradiologists</div>
                    </div>
                  </li>
                  <li class="list-group-item p-1">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <img src={require("../src/Assets/Images/Cardiothoracic-surgeons.png")} class="icon-box" />
                      </div>
                      <div className="flex-grow-1 ms-2">Cardiothoracic surgeons</div>
                    </div>
                  </li>
                  <li class="list-group-item p-1">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <img src={require("../src/Assets/Images/Interventional-Cardiologists.png")} class="icon-box" />
                      </div>
                      <div className="flex-grow-1 ms-2">Interventional Cardiologists</div>
                    </div>
                  </li>
                  <li class="list-group-item p-1">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <img src={require("../src/Assets/Images/Electrophysiologists.png")} class="icon-box" />
                      </div>
                      <div className="flex-grow-1 ms-2">Electrophysiologists</div>
                    </div>
                  </li>
                  <li class="list-group-item p-1">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <img src={require("../src/Assets/Images/nterventional-Radiologists.png")} class="icon-box" />
                      </div>
                      <div className="flex-grow-1 ms-2">Interventional Radiologists</div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="text-start mb-2">
                  <h5 class="fs-16 text-uppercase text-danger">By procedure types</h5>
                  <h3 class="mb-0 fw-bold lh-base fs-4">500+ specific procedure such as:</h3>
                </div>
                <ul class="list-group list-group-flush">
                  <li class="list-group-item p-1">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <img src={require("../src/Assets/Images/Cardiac-Resynchronization-Therapy.png")} class="icon-box" />
                      </div>
                      <div className="flex-grow-1 ms-2"> Cardiac Resynchronization Therapy </div>
                    </div>
                  </li>
                  <li class="list-group-item p-1">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <img src={require("../src/Assets/Images/Cardiac-Ablation.png")} class="icon-box" />
                      </div>
                      <div className="flex-grow-1 ms-2">Cardiac Ablation</div>
                    </div>
                  </li>
                  <li class="list-group-item p-1">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <img src={require("../src/Assets/Images/Atherectomy.png")} class="icon-box" />
                      </div>
                      <div className="flex-grow-1 ms-2">Atherectomy</div>
                    </div>
                  </li>
                  <li class="list-group-item p-1">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <img src={require("../src/Assets/Images/Interventional-Neuroradiologists.png")} class="icon-box" />
                      </div>
                      <div className="flex-grow-1 ms-2">Transcatheter aortic valve replacement (TAVR)</div>
                    </div>
                  </li>
                  <li class="list-group-item p-1">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <img src={require("../src/Assets/Images/Neuroendoscopy.png")} class="icon-box" />
                      </div>
                      <div className="flex-grow-1 ms-2">Neuroendoscopy</div>
                    </div>
                  </li>
                  <li class="list-group-item p-1">
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0">
                        <img src={require("../src/Assets/Images/Interventional-Cardiologists.png")} class="icon-box" />
                      </div>
                      <div className="flex-grow-1 ms-2">Angioplasty</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section class="section bg-grey-light">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-lg-8">
                <div class="text-center mb-4">
                  <h3 class="mb-0 fw-bold lh-base fs-4">Annual Subscription Options</h3>
                </div>
              </div>
            </div>
            <div class="pricetab">
              <div class="d-block d-md-flex justify-content-center gap-0">

                <div class="col-12 col-lg-4 h-100 card card-sedans">
                  <div class="card-header">
                    <h2>Basic</h2>
                    <div class="card-price">
                      <sup><i class="bx bx-dollar"></i></sup><h3 class="cost">6,000</h3> <sub>/ per User</sub>
                    </div>
                  </div>
                  <div class="card-content">
                    <ul class="p-0 fw-bold lh-base fs-16">
                      <li class="d-flex align-items-start mb-2"><img src={require('../src/Assets/Images/check-mark.png')} class="me-2" /> <span>3 minimum number of users</span></li>
                      <li class="d-flex align-items-start mb-2"><img src={require('../src/Assets/Images/check-mark.png')} class="me-2" /> <span>18,000 USD</span></li>
                      <li class="d-flex align-items-start mb-2"><img src={require('../src/Assets/Images/check-mark.png')} class="me-2" /> <span>12 Months Duration</span></li>
                      <li class="d-flex align-items-start"><img src={require('../src/Assets/Images/check-mark.png')} class="me-2" /> <span>Full access to all KOLs in 1 therapy area of choice e.g. interventional cardiology, cardiovascular surgery, diagnostic radiology, endocrinology etc.</span></li>
                    </ul>
                  </div>
                </div>

                <div class="col-12 col-lg-4 h-100 card card-suvs">
                  <div class="card-header">
                    <h2>Standard</h2>
                    <div class="card-price">
                      <sup><i class="bx bx-dollar"></i></sup><h3 class="cost">5,000</h3> <sub>/ per User</sub>
                    </div>
                  </div>
                  <div class="card-content">
                    <ul class="p-0 fw-bold lh-base fs-16">
                      <li class="d-flex align-items-start mb-2"><img src={require('../src/Assets/Images/check-mark.png')} class="me-2" /> <span>4 - 9 number of users</span></li>
                      <li class="d-flex align-items-start mb-2"><img src={require('../src/Assets/Images/check-mark.png')} class="me-2" /> <span>20,000 - 45,000 USD</span></li>
                      <li class="d-flex align-items-start mb-2"><img src={require('../src/Assets/Images/check-mark.png')} class="me-2" /> <span>12 Months Duration</span></li>
                      <li class="d-flex align-items-start"><img src={require('../src/Assets/Images/check-mark.png')} class="me-2" /> <span>Full access to all KOLs in 1 therapy area of choice e.g. interventional cardiology, cardiovascular surgery, diagnostic radiology, endocrinology etc.</span></li>
                    </ul>
                  </div>
                </div>

                <div class="col-12 col-lg-4 h-100 card card-luxury">
                  <div class="card-header">
                    <h2>Premium</h2>
                    <div class="card-price">
                      <sup><i class="bx bx-dollar"></i></sup><h3 class="cost">4,500</h3> <sub>/ per User</sub>
                    </div>
                  </div>
                  <div class="card-content">
                    <ul class="p-0 fw-bold lh-base fs-16">
                      <li class="d-flex align-items-start mb-2"><img src={require('../src/Assets/Images/check-mark.png')} class="me-2" /> <span>4 - 9 number of users</span></li>
                      <li class="d-flex align-items-start mb-2"><img src={require('../src/Assets/Images/check-mark.png')} class="me-2" /> <span>20,000 - 45,000 USD</span></li>
                      <li class="d-flex align-items-start mb-2"><img src={require('../src/Assets/Images/check-mark.png')} class="me-2" /> <span>12 Months Duration</span></li>
                      <li class="d-flex align-items-start"><img src={require('../src/Assets/Images/check-mark.png')} class="me-2" /> <span>Full access to all KOLs in 1 therapy area of choice e.g. interventional cardiology, cardiovascular surgery, diagnostic radiology, endocrinology etc.</span></li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>
        <section id="cta" class="py-4 bg-primary position-relative">
          <div class="bg-overlay bg-overlay-pattern opacity-50"></div>
          <div class="container">
            <div class="row align-items-center gy-4">
              <div class="col-sm">
                <div>
                  <h2 class="text-white mb-0 fw-bold">For more information – Contact us</h2>
                </div>
              </div>
              <div class="col-sm-auto">
                <div>
                  <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#contactform" class="btn btn-brand btn-lg rounded-0">CONTACT MEDTECH EXPERTS</a>
                </div>
              </div>
            </div>
          </div>
        </section>        
        {/* <section class="section">
          <div class="container">
            <div class="justify-content-center row">
              <div class="col-lg-12">
                <div class="text-justify">
                  <p>We ensure your investment is converted into a high volume of actionable insights for better decision making in the industry by identifying the right <strong>key opinion leader healthcare </strong>across different therapeutic areas, specialities and geographies. We help you to know the REAL KOLs better by providing complete and accurate information, but we don’t just stop here! The <strong>KOL Healthcare </strong>Profiles are frequently updated from time to time to provide recent developments or changes in their activities.</p>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        {/* <section class="section bg-light">
          <div class="container">
            <div class="justify-content-center row">
              <div class="col-lg-12">
                <div class="text-start mb-4">
                  <h3 class="mb-0 fw-bold lh-base fs-4">Global Reach Including Key Markets…</h3>
                </div>
              </div>
            </div>
            <div class="justify-content-center row">
              <div class="col-10">
                <img src={require('../src/Assets/Images/Global-Reach.svg')} />
              </div>
            </div>
          </div>
        </section> */}
        <div id="search" className="text-center">
          <p className="service_insights m-0">
            Your One-Stop-Solution for Key Opinion Leaders identification and
            engagement
          </p>
        </div>

        <footer class="footer bg-grey">
          <div class="container">
            <div class="row">
              <div class="col-sm-6 col-md-4 mt-4 col-lg-2 text-align">
                <a className="text-center" href="https://www.medtech-gurus.com">
                  <img src={require('../src/Assets/Images/Medtech_Gurus_logo.png')} width="100" ></img>
                </a>
                <div class="social">
                  <ul class="list-inline my-4">
                    <li class="list-inline-item"><a href="#" class="text-secbrand"><i class='fs-36 bx bxl-linkedin-square' ></i></a></li>
                  </ul>
                </div>
              </div>
              <div class="col-sm-6 col-md-4 col-lg-3 text-align">
                <div class="information">
                  <ul class="list-unstyled footer-link mt-4">
                    <li class="mb-1"><a href="/about us" class="text-decoration-none">About</a></li>
                    <li class="mb-1"><a href="/services" class="text-decoration-none">Services</a></li>
                    <li class="mb-1"><a href="/pricing" class="text-decoration-none">Pricing</a></li>
                    <li class=""><a href="/contact us" class="text-decoration-none">Contact</a></li>
                  </ul>
                </div>
              </div>
              <div class="col-sm-6 col-md-4 col-lg-3 text-align">
                <div class="information">
                  <ul class="list-unstyled footer-link mt-4">
                    <li class="mb-1"><a href="/blogs" class="text-decoration-none">Blogs</a></li>
                    <li class="mb-1"><a href="/casestudy" class="text-decoration-none">Case Study</a></li>
                  </ul>
                </div>
              </div>
              <div class="col-sm-6 col-md-4 col-lg-3 text-align">
                <div class="resources">
                  <ul class="list-unstyled footer-link mt-4">
                    <li class="mb-1"><a href="https://www.cetas.medtech-gurus.comprivacy_policy/" class="text-decoration-none">Privacy Policy</a></li>
                    <li class="mb-1"><a href="https://www.cetas.medtech-gurus.comterms-of-use/" class="text-decoration-none">Terms & Conditions</a></li>
                    <li class="mb-1"><a href="https://www.cetas.medtech-gurus.comcookie-notice/" class="text-decoration-none">Security</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center bg-black p-2">
            <p class="mb-0fs-42 text-white">{global.CopyRightText}</p>
          </div>
        </footer>
        {/* <div class="modal fade" id="point1" tabindex="-1" aria-labelledby="point1Label" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-fourth">
                <h1 class="modal-title fs-5 text-white" id="point1Label">Identification</h1>
                <button type="button" class="btn-close bg-light" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <h4 class="mb-2 lh-base">Identifying the top KOLs according to the respective criteria by:</h4>
                <ul class="list-group list-group-flush">
                  <li class="list-group-item p-1 text-secbrand"><i class='bx bx-check-circle text-secbrand'></i> Capturing the specific information from cherry-picked data sources</li>
                  <li class="list-group-item p-1 text-secbrand"><i class='bx bx-check-circle text-secbrand'></i> Organizing and analyzing the information in a systematic manner</li>
                  <li class="list-group-item p-1 text-secbrand"><i class='bx bx-check-circle text-secbrand'></i> Applying the coherent scoring methodology to filter out the KOLs from regular HCPs</li>
                </ul>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade" id="point2" tabindex="-1" aria-labelledby="point2Label" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-fourth">
                <h1 class="modal-title fs-5 text-white" id="point2Label">Standard Deep Profiling</h1>
                <button type="button" class="btn-close bg-light" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <h4 class="mb-2 lh-base">Deep profile the KOLs with in-depth information of their activities. For the clinical KOLs, some of the aspects of deep profile includes:</h4>
                <ul class="list-group list-group-flush">
                  <li class="list-group-item p-1 text-secbrand"><i class='bx bx-check-circle text-secbrand'></i> Literature Publications</li>
                  <li class="list-group-item p-1 text-secbrand"><i class='bx bx-check-circle text-secbrand'></i> Guidelines development</li>
                  <li class="list-group-item p-1 text-secbrand"><i class='bx bx-check-circle text-secbrand'></i> Clinical Trials</li>
                  <li class="list-group-item p-1 text-secbrand"><i class='bx bx-check-circle text-secbrand'></i> Events/Conferences</li>
                  <li class="list-group-item p-1 text-secbrand"><i class='bx bx-check-circle text-secbrand'></i> Advisory Board/Committee</li>
                </ul>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade" id="point3" tabindex="-1" aria-labelledby="point3Label" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-fourth">
                <h1 class="modal-title fs-5 text-white" id="point3Label">Standard Ranking/Rating</h1>
                <button type="button" class="btn-close bg-light" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <p class="text-secbrand text-justify">Robust 5-point rating methodology to rank the KOL based on the quantity and quality/level of engagement on various aspects. For e.g., for the clinical KOLs, the ratings and rankings are based on the performances on each of the above 5 aspects. Our ranking strategy doesn’t only apply to Global aspects but also based on the filters applied on Geography, Specialty, Procedure types, etc.</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade" id="point4" tabindex="-1" aria-labelledby="point4Label" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-fourth">
                <h1 class="modal-title fs-5 text-white" id="point4Label">Custom Deep Profiling and Ranking/Rating</h1>
                <button type="button" class="btn-close bg-light" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <p class="text-secbrand text-justify">We can also provide custom deep profile and ranking/rating based on the specific KOL profiles that you select.</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade" id="point5" tabindex="-1" aria-labelledby="point5Label" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-fourth">
                <h1 class="modal-title fs-5 text-white" id="point5Label">Classification of clinical KOLs</h1>
                <button type="button" class="btn-close bg-light" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <h4 class="mb-2 lh-base">We can help you identify the rock stars, the rising stars, and look out for the declining stars:</h4>
                <ul class="list-group list-group-flush">
                  <li class="list-group-item p-1 text-secbrand"><i class='bx bx-check-circle text-secbrand'></i> <strong>Rock stars:</strong> These are the top KOLs who are on top of their field consistently over the past 3-5 years.</li>
                  <li class="list-group-item p-1 text-secbrand"><i class='bx bx-check-circle text-secbrand'></i> <strong>Rising stars:</strong> These are the KOLs who have potential to become Rock stars and you can catch them early and start engaging them.</li>
                  <li class="list-group-item p-1 text-secbrand"><i class='bx bx-check-circle text-secbrand'></i> <strong>Declining stars:</strong> These are the top KOLs who are starting to show signs of decline in the past 3-5 years and may not have the same influence in the near future.</li>
                </ul>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade" id="point6" tabindex="-1" aria-labelledby="point6Label" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-fourth">
                <h1 class="modal-title fs-5 text-white" id="point6Label">Long-term KOL Engagements</h1>
                <button type="button" class="btn-close bg-light" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <p class="text-secbrand text-justify">We provide tracking and managing the interactions and contracts with the KOLs throughout the duration of contract.</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade" id="point7" tabindex="-1" aria-labelledby="point7Label" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-fourth">
                <h1 class="modal-title fs-5 text-white" id="point7Label">Interviews/Podcasts with KOLs</h1>
                <button type="button" class="btn-close bg-light" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <p class="text-secbrand text-justify">We also support interview moderations/podcasts with KOLS for various engagements using our in-house expert Healthcare native moderators who have 10+ years of moderation experience.</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade" id="point8" tabindex="-1" aria-labelledby="point8Label" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-fourth">
                <h1 class="modal-title fs-5 text-white" id="point8Label">Recruitment of KOLs for Engagements</h1>
                <button type="button" class="btn-close bg-light" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <h4 class="mb-2 lh-base">Set-up KOL interactions and engagement with MedTech companies by:</h4>
                <ul class="list-group list-group-flush">
                  <li class="list-group-item p-1 text-secbrand"><i class='bx bx-check-circle text-secbrand'></i> Connecting with the KOLs and recruiting them.</li>
                  <li class="list-group-item p-1 text-secbrand"><i class='bx bx-check-circle text-secbrand'></i> Building up contracts between the finalized KOLs and the MedTech companies for further interactions.</li>
                  <li class="list-group-item p-1 text-secbrand"><i class='bx bx-check-circle text-secbrand'></i> Setting up interactions and engagement between the KOLs and the MedTech companies based on schedule.</li>
                </ul>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade" id="point9" tabindex="-1" aria-labelledby="point9Label" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-fourth">
                <h1 class="modal-title fs-5 text-white" id="point9Label">KOL Influence Mapping</h1>
                <button type="button" class="btn-close bg-light" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <p class="text-secbrand text-justify">Do you want to know does a KOL have influence among HCPs or other healthcare personnel in one city or one region or one country or across the globe? We can provide a complete contextual understanding and influence mapping of a KOL geographically.</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade" id="point10" tabindex="-1" aria-labelledby="point10Label" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-fourth">
                <h1 class="modal-title fs-5 text-white" id="point10Label">KOL Network</h1>
                <button type="button" class="btn-close bg-light" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <p class="text-secbrand text-justify">We provide complete picture of the KOL landscape vis-à-vis other KOLs. We provide significant insights on KOLs’ connection among their peers with regards to shared activities vis-à-vis publications, guidelines, clinical trials, conferences, and Advisory Board by Geography.</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div> */}

        <div class="modal fade" id="contactform" tabindex="-1" aria-labelledby="contactformLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-fourth">
                <h1 class="modal-title fs-5 text-white" id="contactformLabel">Get in touch with us</h1>
                <button type="button" class="btn-close bg-danger" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <h5 className="mb-2">Please fill in the form below and we will get in touch within 1 working day</h5>
                <form className="row align-items-center justify-content-between g-2">
                  <div className="col-md-12 col-lg-6">
                    <div class="d-flex align-items-center justify-content-between"><label for="" className="form-label m-0">Full Name:<span class="mandatory">*</span></label> <div className="error"> {this.state.UsernameErr}</div></div>
                    <input type="text" className="form-control mb-0" placeholder="" id="" aria-describedby="" value={this.state.GetInTouchData.client_name} onChange={(e) => {
                      let { GetInTouchData } = this.state;
                      GetInTouchData.client_name = e.target.value;
                      this.setState({ GetInTouchData });
                    }}
                    ></input>
                  </div>
                  <div className="col-md-12 col-lg-6">
                    <div class="d-flex align-items-center justify-content-between"><label for="" className="form-label m-0">Your work email:<span class="mandatory">*</span></label> <div className="error"> {" "} {this.state.UseremailErr}</div></div>
                    <input type="text" className="form-control mb-0" placeholder="" id="" aria-describedby="" value={this.state.GetInTouchData.email_id}
                      onChange={(e) => {
                        let { GetInTouchData } = this.state;
                        GetInTouchData.email_id = e.target.value;
                        this.setState({ GetInTouchData });
                      }}
                    ></input>
                  </div>
                  <div className="col-md-12 col-lg-6">
                    <div class="d-flex align-items-center justify-content-between"><label for="" className="form-label m-0">Your work phone:<span class="mandatory">*</span></label> <div className="error"> {this.state.PhoneErr}</div></div>
                    <PhoneInput
                      inputStyle={{
                        width: "100%",
                        height: "50px",
                        fontSize: "15px",
                      }}
                      width="50%"
                      country={"in"}
                      value={this.state.GetInTouchData.mobile_no}
                      onChange={(mobile_no) => {
                        let { GetInTouchData } = this.state;
                        GetInTouchData.mobile_no = mobile_no;
                        this.setState({ GetInTouchData });
                      }}
                    />
                  </div>
                  <div className="col-md-12 col-lg-6">
                    <div class="d-flex align-items-center justify-content-between"><label for="" className="form-label m-0">Your company name:<span class="mandatory">*</span></label><div className="error">{" "}{this.state.CompanyNameErr}</div></div>
                    <input
                      type="text"
                      className="form-control mb-0"
                      placeholder=""
                      id=""
                      aria-describedby=""
                      value={this.state.GetInTouchData.company_nm}
                      onChange={(e) => {
                        let { GetInTouchData } = this.state;
                        GetInTouchData.company_nm = e.target.value;
                        this.setState({ GetInTouchData });
                      }}
                    ></input>
                  </div>
                  <div className="col-12">
                    <div class="d-flex align-items-center justify-content-between"><label for="" className="form-label m-0">Your job location:<span class="mandatory">*</span></label> <div className="error"> {" "} {this.state.DesignationErr} </div></div>
                    <input
                      type="text"
                      className="form-control mb-0"
                      placeholder=""
                      id=""
                      aria-describedby=""
                      value={this.state.GetInTouchData.designation}
                      onChange={(e) => {
                        let { GetInTouchData } = this.state;
                        GetInTouchData.designation = e.target.value;
                        this.setState({ GetInTouchData });
                      }}
                    ></input>
                  </div>
                  <div className="col-12">
                    <div class="d-flex align-items-center justify-content-between"><label for="" className="form-label m-0">Message:<span class="mandatory">*</span></label><div className="error"> {this.state.MessageErr}</div></div>
                    <textarea
                      name=""
                      placeholder=""
                      className="form-control mb-0"
                      id=""
                      rows="3"
                      value={this.state.GetInTouchData.message}
                      onChange={(e) => {
                        let { GetInTouchData } = this.state;
                        GetInTouchData.message = e.target.value;
                        this.setState({ GetInTouchData });
                      }}
                    ></textarea>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                {/* <button onClick={this.GetInTouchfun.bind(this)} className="btn btn-brand">Send Message</button> */}
                <a
                  onClick={this.GetInTouchfun.bind(this)}
                  className="btn btn-brand"
                >
                  Submit
                </a>
              </div>
            </div>
          </div>
        </div>
        <Modal
          isOpen={this.state.searchModalOpen}
          toggle={() => this.closeSearchModal()}
          centered
          fullscreen
        >
          <ModalHeader toggle={() => this.closeSearchModal()}>
            <h3>{this.state.selectedKol} KOL</h3>
          </ModalHeader>
          <ModalBody style={{ padding: "0px 30px" }}>
            <div style={{ margin: "20px 0px" }}>
              {this.state.selectedKol === this.state.kols[0].label ? (
                <Form>
                  <FormGroup>
                    <Label>Select Country</Label>
                    <Typeahead
                      id="clinical_country"
                      multiple
                      onChange={(e) =>
                        this.handleClinicalFormField("country", e)
                      }
                      options={this.state.countryList}
                      placeholder="Choose a Country..."
                      selected={this.state.clinicalKolForm.country}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label>
                      Select Speciality <span class="mandatory">*</span>
                    </Label>
                    <Typeahead
                      id="speciality"
                      invalid={this.validateField(
                        "clinicalKolForm",
                        "speciality"
                      )}
                      onChange={(e) =>
                        this.handleClinicalFormField("speciality", e)
                      }
                      options={this.state.SpecialityData}
                      placeholder="Choose a Speciality..."
                      selected={this.state.clinicalKolForm.speciality}
                    />
                    {this.validateField("clinicalKolForm", "speciality") && (
                      <FormFeedback>Please Select Speciality</FormFeedback>
                    )}
                  </FormGroup>
                  <FormGroup style={this.state.subSpecilityVisible ? {} : { "display": "none" }}>
                    <Label>Select Sub-Speciality</Label>
                    <Typeahead
                      id="subSpeciality"
                      multiple
                      onChange={(e) =>
                        this.handleClinicalFormField("subSpeciality", e)
                      }
                      options={this.state.SubSpecialityType}
                      placeholder="Choose a Sub-speciality..."
                      selected={this.state.clinicalKolForm.subSpeciality}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label>Please specify the procedure/condition (if any)</Label>
                    <div
                      onChange={this.onProcedureChanged}
                      style={{
                        height: "30px",
                        width: "100%",
                        // color: "#949393",
                        backgroundColor: "#fff",
                        borderColor: "#ccc",
                      }}
                    >
                      <input
                        type="radio"
                        value="Procedure"
                        name="Procedure"
                        checked={this.state.procedureSelected}
                      />
                      <span className="Radio_button">Procedure </span>
                      <input
                        type="radio"
                        value="Condition"
                        name="Procedure"
                        checked={this.state.conditionSelected}
                        style={{ marginLeft: "5%" }}
                      />{" "}
                      Condition
                    </div>

                    <div className="Quotblanck">
                      {this.state.profiletypeErr ? this.state.profiletypeErr : null}
                    </div>
                  </FormGroup>
                  {this.state.Procedure && (
                    <FormGroup>
                      <Label>Select {this.state.Procedure}</Label>
                      <Typeahead
                        ref='typeahead'
                        id="procedure"
                        onChange={(e) =>
                          this.handleClinicalFormField("procedure", e)
                        }
                        options={this.state.ProcedureType}
                        placeholder={`Choose a ${this.state.Procedure}...`}
                        selected={this.state.clinicalKolForm.procedure}
                      />
                    </FormGroup>
                  )}


                </Form>
              ) : (
                <Form>
                  <FormGroup>
                    <Label>
                      Select KOL Subtype <span class="mandatory">*</span>
                    </Label>
                    <Typeahead
                      id="kolSubType"
                      onChange={(e) =>
                        this.handleNonClinicalFormField("kolSubType", e)
                      }
                      options={this.state.kolSubType}
                      placeholder="Choose a KOL Subtype..."
                      selected={this.state.nonClinicalKolForm.kolSubType}
                    />

                    {this.validateField("nonClinicalKolForm", "kolSubType") && (
                      <FormFeedback>Please Select Sub-KOL Type</FormFeedback>
                    )}
                  </FormGroup>
                  <FormGroup>
                    <Label>Select Country</Label>
                    <Typeahead
                      id="nonclinical_country"
                      multiple
                      onChange={(e) =>
                        this.handleNonClinicalFormField("country", e)
                      }
                      options={this.state.countryList}
                      placeholder="Choose a Country..."
                      selected={this.state.nonClinicalKolForm.country}
                    />
                  </FormGroup>
                </Form>
              )}
            </div>
            <br />
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={() => this.submitKOLform()}
              className="btn btn-brand ms-lg-3"
              disabled={this.state.subClinicalKolEnabled}
            >
              Submit
            </Button>{" "}
            <Button color="secondary" onClick={() => this.closeSearchModal()}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={this.state.showNonClinicalContactForm}
          toggle={() => this.closeNonClinicalContactModal()}
          size="lg"
          style={{ maxWidth: "800px", width: "100%" }}
          centered
          fullscreen
        >
          <ModalHeader toggle={() => this.closeNonClinicalContactModal()}>
            <h1>Get in touch with us</h1>
            <p>
              Please fill in the form below and we will get in touch within 1
              working day
            </p>
          </ModalHeader>
          <ModalBody style={{ padding: "0px 30px" }}>
            <form className="p-lg-5 col-12 row g-3">
              <div className="col-lg-6">
                <label for="" className="form-label">
                  KOL Subtype:<span class="mandatory">*</span>
                </label>
                <Input
                  type="select"
                  id="SpecilitySelect"
                  value={this.state.nonClinicalKolForm.kolSubType[0]?.label}
                  onChange={(e) =>
                    this.handleNonClinicalFormField(
                      "kolSubType",
                      e.target.value
                    )
                  }
                  style={{ backgroundColor: "white" }}
                >
                  <option>Select KOL Subtype</option>
                  {this.state.kolSubType.map((kol) => (
                    <option key={kol.id} value={kol.label}>
                      {kol.label}
                    </option>
                  ))}
                </Input>
                {this.validateContactFormField("kolSubType") && (
                  <FormFeedback>Please Select Sub-KOL Type</FormFeedback>
                )}
                <br />
              </div>
              <div className="col-lg-6">
                <label for="" className="form-label">
                  Country:
                </label>
                <Input
                  type="select"
                  id="SpecilitySelect"
                  multi
                  style={{ backgroundColor: "white" }}
                  value={this.state.nonClinicalKolForm.country[0]?.label}
                  onChange={(e) =>
                    this.handleNonClinicalFormField("country", e.target.value)
                  }
                >
                  <option value="">Select Country</option>
                  {this.state.countryList.map((country) => {
                    // console.log(country)
                    return (<option key={country.value} value={country.label}>
                      {country.label}
                    </option>)
                  })}
                </Input>
              </div>
              <div className="col-lg-6">
                <label for="" className="form-label">
                  Full Name:<span class="mandatory">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder=""
                  id=""
                  aria-describedby=""
                  value={this.state.nonClinicalKolForm.fullName}
                  onChange={(e) => {
                    this.handleNonClinicalFormField("fullName", e.target.value);
                  }}
                ></input>
                {this.validateContactFormField("fullName") && (
                  <div className="error">Please Enter Full Name</div>
                )}
              </div>

              <div className="col-lg-6">
                <label for="" className="form-label">
                  Your work email:<span class="mandatory">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder=""
                  id=""
                  aria-describedby=""
                  value={this.state.nonClinicalKolForm.workEmail}
                  onChange={(e) => {
                    this.handleNonClinicalFormField(
                      "workEmail",
                      e.target.value
                    );
                  }}
                ></input>
                {this.validateContactFormField("workEmail") && (
                  <div className="error">Please Enter Work Email</div>
                )}
              </div>
              <div className="col-lg-6">
                <label for="" className="form-label">
                  Your work phone:<span class="mandatory">*</span>
                </label>

                <PhoneInput
                  inputStyle={{
                    width: "100%",
                    height: "50px",
                    fontSize: "15px",
                  }}
                  width="50%"
                  country={"in"}
                  value={this.state.nonClinicalKolForm.phone}
                  onChange={(mobile_no) => {
                    this.handleNonClinicalFormField("phone", mobile_no);
                  }}
                />

                {this.validateContactFormField("phone") && (
                  <div
                    style={{ marginTop: "10px !important" }}
                    className="error"
                  >
                    Please Enter Mobile Number
                  </div>
                )}
              </div>
              <div className="col-lg-6">
                <label for="" className="form-label">
                  Your company name:<span class="mandatory">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder=""
                  id=""
                  aria-describedby=""
                  value={this.state.nonClinicalKolForm.companyName}
                  onChange={(e) => {
                    this.handleNonClinicalFormField(
                      "companyName",
                      e.target.value
                    );
                  }}
                ></input>
                {this.validateContactFormField("companyName") && (
                  <div className="error">Please Enter Work Email</div>
                )}
              </div>
              <div className="col-lg-12">
                <label for="" className="form-label">
                  Your job title:<span class="mandatory">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder=""
                  id=""
                  aria-describedby=""
                  value={this.state.nonClinicalKolForm.jobTitle}
                  onChange={(e) => {
                    this.handleNonClinicalFormField("jobTitle", e.target.value);
                  }}
                ></input>
                {this.validateContactFormField("jobTitle") && (
                  <div className="error">Please Enter Job Title</div>
                )}
              </div>
              <div className="col-lg-12">
                <label for="exampleInputEmail1" className="form-label">
                  Message:<span class="mandatory">*</span>
                </label>
                <textarea
                  name=""
                  placeholder=""
                  className="form-control"
                  id=""
                  rows="2"
                  value={this.state.nonClinicalKolForm.message}
                  onChange={(e) => {
                    this.handleNonClinicalFormField("message", e.target.value);
                  }}
                ></textarea>

                {this.validateContactFormField("message") && (
                  <div className="error">Please Enter Message</div>
                )}
              </div>
            </form>
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={() =>
                this.setState({
                  nonClinicalContactFormSubmitted: true,
                  showNonClinicalContactForm: false,
                })
              }
              className="btn btn-brand ms-lg-3"
            >
              Submit
            </Button>{" "}
            <Button
              color="secondary"
              onClick={() => this.closeNonClinicalContactModal()}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </body>
    );
  }
}

export default KOLidentification;
